
  (function () {

    /* ── Real viewport height (excludes mobile browser chrome) ── */
    function setVhProperty() {
      document.documentElement.style.setProperty("--vh-100", window.innerHeight + "px");
    }
    setVhProperty();
    window.addEventListener("resize", setVhProperty);

    var SEARCH_API_BASE = "https://apps.bellavitaorganic.com";
    var SHOP_DOMAIN = window.__bvSearchShopDomain;
    function getSessionId() {
      try {
        var key = 'bv_search_session_id';
        var id = sessionStorage.getItem(key);
        if (!id) {
          id = (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function')
            ? crypto.randomUUID()
            : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (Math.random() * 16) | 0;
                return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
              });
          sessionStorage.setItem(key, id);
        }
        return id;
      } catch(e) { return ''; }
    }
    var debounceTimer = null;
    var inputDebounceTimer = null;
    var lastQuery = "";
    var _pendingQuery = "";
    var activeRequestId = 0;
    var isPopupOpen = false;

    /* DOM references — set inside initCustomSearchPopup() */
    var popup = null;

    var trendingSection = null;
    var topProductsSection = null;
    var mainBannerSection = null;
    var categoryBannersSection = null;

    /* Injected container for API results — created once, never null after init */
    var apiResultsEl = null;


    function escapeHtml(v) {
      if (v == null) return "";
      return String(v)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    }

    /*

    Here we are integrating with a custom search API (e.g. Bellavita's /suggest endpoint) 
    to fetch dynamic suggestions and product results based on user query.

    */
    function apiFetch(path) {
      return fetch(SEARCH_API_BASE + path, {
        headers: {
          /*       
            we are fetching shop domain from liquid variable and passing it in header for 
            API to identify the store and return results accordingly
          */
          "X-Shop-Domain": SHOP_DOMAIN,
          "X-Session-Id": getSessionId()
        }
      }).then(function (r) {
        if (!r.ok) throw new Error("API error: " + r.status);
        return r.json();
      });
    }

    /* ── Trending filter ─────────────────────────────────────────────
       Only toggles li.style.display — NEVER rewrites trendingSection HTML */

    function updateTrendingFilter(query, apiSuggestions) {
      if (!trendingSection) return;
      try {
        var q = (query || "").toLowerCase().trim();

        /* Always remove previously injected dynamic suggestion pills first */
        var oldDynamic = trendingSection.querySelectorAll(".trending-kw-dynamic");
        Array.prototype.forEach.call(oldDynamic, function (el) {
          if (el.parentNode) el.parentNode.removeChild(el);
        });

        /* Toggle visibility of static keyword items */
        var lis = trendingSection.querySelectorAll(".trending-keyword-item");
        var anyVisible = false;
        Array.prototype.forEach.call(lis, function (li) {
          var a = li.querySelector("a");
          var match = !q || (a && a.textContent.toLowerCase().indexOf(q) !== -1);
          li.style.display = match ? "" : "none";
          if (match) anyVisible = true;
        });

        if (q && !anyVisible && apiSuggestions && apiSuggestions.length) {
          /* No static match — inject API suggest titles as dynamic trending pills */
          var kwList = trendingSection.querySelector(".trending-keywords");
          if (kwList) {
            Array.prototype.forEach.call(apiSuggestions, function (p) {
              if (!p.title || !p.title.trim()) return;
              var li = document.createElement("li");
              li.className = "trending-keyword-item trending-kw-dynamic";
              var a = document.createElement("a");
              a.href = "/pages/custom-search?q=" + encodeURIComponent(p.title);
              a.textContent = p.title;
              li.appendChild(a);
              kwList.appendChild(li);
            });
            anyVisible = true;
          }
        }

        /* Hide entire trending section when nothing is visible; show when items exist */
        trendingSection.style.display = (q && !anyVisible) ? "none" : "";

        /* Always hide the no-match placeholder — never show it */
        var noMatch = trendingSection.querySelector(".trending-no-match");
        if (noMatch) noMatch.style.display = "none";
      } catch (e) {
        /* Silent — trending filter failing must never block popup open */
        
      }
    }

    /* API product cards — renders into apiResultsEl with full product data */

    function renderProductCards(items, query) {
      if (!apiResultsEl) return;

      var _popupHiddenTags = ["product-hide", "hidden", "skip-collection"];
      if (items && items.length) {
        items = Array.prototype.filter.call(items, function(p) {
          var tags = p.tags || [];
          if (typeof tags === "string") tags = tags.split(",");
          for (var _t = 0; _t < tags.length; _t++) {
            var tag = (tags[_t] + "").trim().toLowerCase();
            if (_popupHiddenTags.indexOf(tag) !== -1) return false;
          }
          return true;
        });
      }

      if (!items || !items.length) {
        if (apiResultsEl) {
          apiResultsEl.innerHTML = "";
          apiResultsEl.style.display = "none";
        }
        if (topProductsSection) topProductsSection.style.display = "";
        return;
      }

      var html =
        "<div style=\"display:flex;align-items:center;justify-content:space-between;margin-bottom:0.8rem;\">" +
        "<h2 style=\"font-size:18px;font-weight:700;margin:0;color:#000;\">Best Sellers</h2>" +
        "<a href=\"/pages/custom-search?q=" + encodeURIComponent(query) + "\" style=\"font-size:13px;color:#333;text-decoration:none;border:1px solid #d5d5d5;padding:4px 12px;border-radius:4px;\">See all &rarr;</a>" +
        "</div>" +
        "<div class=\"top-products-wrapper\">";

      Array.prototype.forEach.call(items, function (p) {
        var imgs = p.images || [];
        var imgUrl = imgs.length ? imgs[0].src : (p.image || "");
        var title = p.title || "";
        var handle = p.handle || "";
        var v = (p.variants && p.variants[0]) || {};
        var price = v.price || p.minPrice || 0;
        var compareAt = v.compareAtPrice || 0;
        if (compareAt <= price) compareAt = 0;
        var discount = (compareAt && compareAt > price) ? Math.round(((compareAt - price) / compareAt) * 100) : 0;
        var gid = v.shopifyId || "";
        var variantId = gid.replace(/.*\//, "");
        var pdpUrl = "/products/" + encodeURIComponent(handle);

        var sep = imgUrl && imgUrl.indexOf("?") === -1 ? "?" : "&";
        var imgTag = imgUrl
          ? "<img src=\"" + escapeHtml(imgUrl) + sep + "width=400\" alt=\"" + escapeHtml(title) + "\" loading=\"eager\" width=\"400\" height=\"400\">"
          : "";

        html += "<div class=\"top-products-card product-card\">";
        html += "<div class=\"top-product-img-wrap\">";
        html += "<a href=\"" + pdpUrl + "\">" + imgTag + "</a>";
        if (discount > 0) {
          html += "<div class=\"top-product-discount\">" + discount + "% OFF</div>";
        }
        html += "</div>";
        html += "<h3><a href=\"" + pdpUrl + "\">" + escapeHtml(title.length > 18 ? title.substring(0, 18) + "..." : title) + "</a></h3>";
        html += "<p><span>\u20B9" + Number(price).toLocaleString("en-IN") + "</span>";
        if (compareAt) {
          html += " <del>\u20B9" + Number(compareAt).toLocaleString("en-IN") + "</del>";
        }
        html += "</p>";
        if (variantId && v.availableForSale !== false) {
          html += "<button type=\"button\" class=\"search-atc\" data-csr-atc=\"" + variantId + "\">ADD TO CART</button>";
        } else {
          html += "<a href=\"" + pdpUrl + "\" class=\"search-atc\">ADD TO CART</a>";
        }
        html += "</div>";
      });

      html += "</div>";
      apiResultsEl.innerHTML = html;
    }

    /* Categories filter (shown when user types a query) */
    var _categoriesEl = null;
    function updateCategoriesFilter(categories) {
      if (!_categoriesEl) {
        _categoriesEl = document.createElement("section");
        _categoriesEl.className = "custom-search-categories-dynamic";
        _categoriesEl.style.cssText = "padding-top:0.5rem;padding-bottom:0.5rem;";
        _categoriesEl.style.display = "none";
        if (trendingSection && trendingSection.parentNode) {
          trendingSection.parentNode.insertBefore(_categoriesEl, trendingSection);
        }
      }
      if (!categories || !categories.length) {
        _categoriesEl.style.display = "none";
        return;
      }
      var html = "<h2 style=\"font-size:18px;font-weight:700;margin:0 0 8px;color:#000;\">Categories</h2>";
      html += "<ul class=\"trending-keywords\">";
      categories.forEach(function(c) {
        var url = c.url || "/pages/custom-search?q=" + encodeURIComponent(c.title);
        html += "<li class=\"trending-keyword-item\"><a href=\"" + escapeHtml(url) + "\">" + escapeHtml(c.title) + "</a></li>";
      });
      html += "</ul>";
      _categoriesEl.innerHTML = html;
      _categoriesEl.style.display = "";
    }


    /* ── View state ──────────────────────────────────────────────────
       showDefaultView: restore static state (popup just opened / query cleared)
       showSuggestView: swap to API results (user is typing)
       Banners are NEVER hidden in either state.                        */

    function showDefaultView() {
      updateTrendingFilter("");

      if (topProductsSection) topProductsSection.style.display = "";
      if (apiResultsEl)       apiResultsEl.style.display       = "none";

      if (mainBannerSection)      mainBannerSection.style.display      = "";
      if (categoryBannersSection) categoryBannersSection.style.display = "";

      /* Hide dynamic categories section when returning to default view */
      if (_categoriesEl) _categoriesEl.style.display = "none";
    }

    function showSuggestView(query) {
      /* Step 1: filter trending in-place */
      updateTrendingFilter(query);

      /* Step 2: swap products section for API results.
         Fix 5: Do NOT set innerHTML — keep previous results visible
         so there is no loading flash. Fixed min-height (Fix 6) holds the space. */
      if (topProductsSection) topProductsSection.style.display = "none";
      if (apiResultsEl) apiResultsEl.style.display = "";

      /* Step 3: banners always visible */
      if (mainBannerSection)      mainBannerSection.style.display      = "";
      if (categoryBannersSection) categoryBannersSection.style.display = "";
    }

    /* ── Shimmer placeholder while API call is in-flight ─────────── */
    function showShimmer() {
      if (!apiResultsEl) return;
      var html = '<div class="top-products-wrapper">';
      for (var i = 0; i < 6; i++) {
        html += '<div class="search-shimmer-card">';
        html += '<div class="search-shimmer-img"></div>';
        html += '<div class="search-shimmer-line medium"></div>';
        html += '<div class="search-shimmer-line short"></div>';
        html += '<div class="search-shimmer-btn"></div>';
        html += '</div>';
      }
      html += '</div>';
      apiResultsEl.innerHTML = html;
      apiResultsEl.style.display = '';
    }

    /* ── Query handler ───────────────────────────────────────────────
       Debounced — fires /search/products for full variant data        */

    function handleQuery(value) {
      if (!isPopupOpen) return;   /* belt-and-suspenders: ignore debounce fires after close */
      var query = (value || "").trim();
      clearTimeout(debounceTimer);

      if (!query.length) {
        lastQuery = "";
        showDefaultView();
        return;
      }

      /* If the trimmed query is identical to what was already fetched,
         results are already displayed — skip shimmer and extra API call.
         Do NOT call showSuggestView here: it would hide topProductsSection
         and expose an empty apiResultsEl, causing a white-space gap. */
      if (query === lastQuery) return;

      /* Show shimmer immediately so user sees feedback while debounce waits */
      showSuggestView(query);
      showShimmer();

      /* Store the latest query so the timer can read the FINAL value,
         not a stale closure value from when setTimeout was scheduled. */
      _pendingQuery = query;

      /* Single 500ms debounce — only the last keystroke fires the API.
         When the timer fires, it reads _pendingQuery (the latest value)
         instead of the closure `query`, so intermediate keystrokes are skipped. */
      debounceTimer = setTimeout(function () {
        var q = _pendingQuery;
        if (!q) return;
 
        var _shimmerStuck = apiResultsEl && !!apiResultsEl.querySelector('.search-shimmer-card');
        if (q === lastQuery && !_shimmerStuck) return;
        lastQuery = q;

        var rid = ++activeRequestId;

        /* ── Autocomplete API → trending search suggestions (parallel) ── */
        var autocompletePromise = apiFetch(
          "/api/v1/search/autocomplete?q=" + encodeURIComponent(q) +
          "&productLimit=5&categoryLimit=5"
        );

        /* ── Products API → full product data with variants (parallel) ── */
        var productsPromise = apiFetch(
          "/api/v1/search/products?q=" + encodeURIComponent(q) + "&limit=8"
        );

        /* Handle autocomplete result as soon as it arrives */
        autocompletePromise.then(function (res) {
          if (rid !== activeRequestId) return;
          var suggestions = [];
          var categories = [];
          var payload = (res && res.data) ? res.data : res;
          if (payload && payload.products && payload.products.length) {
            Array.prototype.forEach.call(payload.products, function (p) {
              suggestions.push({ title: p.title, url: "/products/" + (p.handle || "") });
            });
          }
          if (payload && payload.categories && payload.categories.length) {
            Array.prototype.forEach.call(payload.categories, function (c) {
              var catName = c.value || c.title || c.name || "";
              if (catName) {
                categories.push({ title: catName, url: "/pages/custom-search?q=" + encodeURIComponent(catName) });
              }
            });
          }
          updateTrendingFilter(q, suggestions);
          updateCategoriesFilter(categories);
        }).catch(function () {
          if (rid !== activeRequestId) return;
          updateTrendingFilter(q, []);
          updateCategoriesFilter([]);
        });

        /* Handle products result as soon as it arrives */
        productsPromise
          .then(function (res) {
            if (rid !== activeRequestId) return;
            if (res && res.success && res.data && res.data.length) {
              renderProductCards(res.data, q);
            } else {
              /* No results — fall back to static top products */
              renderProductCards([], q);
            }
          })
          .catch(function (err) {
            if (rid !== activeRequestId) return;
            /* On error — fall back to static top products silently */
            renderProductCards([], q);
            if (window.console && window.console.error) window.console.error("Search error:", err);
          });

      }, 500); /* 500ms debounce — API fires only after user stops typing */
    }

    /* ── Init ────────────────────────────────────────────────────── */

    function initCustomSearchPopup() {
      popup               = document.querySelector("[data-custom-search-root]");

      trendingSection     = document.querySelector("[data-custom-search-trending]");
      topProductsSection  = document.querySelector("[data-custom-search-top-products]");
      mainBannerSection   = document.querySelector("[data-custom-search-main-banner]");
      categoryBannersSection = document.querySelector("[data-custom-search-category-banners]");

      /* Guard: popup element must exist */
      if (!popup) return;

      /* Guard: prevent double-init (e.g. snippet included twice) */
      if (popup.dataset.searchInitDone === "true") return;
      popup.dataset.searchInitDone = "true";

      /* Inject #search-api-results div directly before the static top-products section.
         This is the ONLY DOM mutation — static section HTML is never changed. */
      apiResultsEl = document.createElement("div");
      apiResultsEl.id = "search-api-results";
      apiResultsEl.style.display = "none";
      if (topProductsSection && topProductsSection.parentNode) {
        topProductsSection.parentNode.insertBefore(apiResultsEl, topProductsSection);
        /* The parent has no class of its own, so give it one: it is the only box
          that stays in layout while the two children swap, and therefore the
          only place a height reservation actually holds. */
        topProductsSection.parentNode.classList.add("csr-swap-host");
      }

      /* ── Fallback: fetch Best Sellers from Shopify collections API (same-origin, no CORS) ── */
      var _apiFallback = document.getElementById("top-products-api-fallback");
      if (_apiFallback) {
        fetch("/collections/bestsellers/products.json?limit=8")
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
          .then(function (res) {
            var products = res.products || [];
            if (!products.length) return;
            var html = "";
            var handles = [];
            products.forEach(function (p) {
              var img = (p.images && p.images[0] && p.images[0].src) || (p.image && p.image.src) || "";
              var title = p.title || "";
              var handle = p.handle || "";
              handles.push({ handle: handle, title: title });
              var v = (p.variants && p.variants[0]) || {};
              var price = parseFloat(v.price) || 0;
              var compareAt = parseFloat(v.compare_at_price) || 0;
              var discount = (compareAt && compareAt > price) ? Math.round(((compareAt - price) / compareAt) * 100) : 0;
              var variantId = v.id || "";
              var pdpUrl = "/products/" + handle;

              html += '<div class="top-products-card product-card" data-bs-handle="' + escapeHtml(handle) + '">';
              html += '<div class="top-product-img-wrap">';
              html += '<a href="' + pdpUrl + '">';
              if (img) {
                var sep = img.indexOf('?') === -1 ? '?' : '&';
                html += '<img src="' + escapeHtml(img) + sep + 'width=400" alt="' + escapeHtml(title) + '" width="400" height="400" loading="lazy">';
              }
              html += '</a>';
              if (discount > 0) {
                html += '<div class="top-product-discount">' + discount + '% OFF</div>';
              }
              html += '</div>';
              html += '<h3><a href="' + pdpUrl + '">' + escapeHtml(title.length > 18 ? title.substring(0, 18) + '...' : title) + '</a></h3>';
              html += '<div class="top-product-rating" data-rating-handle="' + escapeHtml(handle) + '"></div>';
              html += '<p><span>₹' + Number(price).toLocaleString('en-IN') + '</span>';
              if (compareAt && compareAt > price) {
                html += ' <del>₹' + Number(compareAt).toLocaleString('en-IN') + '</del>';
              }
              html += '</p>';
              if (variantId) {
                html += '<button type="button" class="search-atc" data-csr-atc="' + variantId + '">ADD TO CART</button>';
              } else {
                html += '<a href="' + pdpUrl + '" class="search-atc">ADD TO CART</a>';
              }
              html += '</div>';
            });
            _apiFallback.innerHTML = html;

            /* Enrich with ratings from search API. Query by the product's own
               title (more reliable than handle-as-words) and match the exact
               handle; fall back to a normalized-title match so a product that
               ranks below the first result still gets its rating. */
            handles.forEach(function(h) {
              var q = (h.title || h.handle.replace(/-/g, ' ')).trim();
              var normTitle = (h.title || '').trim().toLowerCase();
              fetch(SEARCH_API_BASE + "/api/v1/search/products?q=" + encodeURIComponent(q) + "&limit=20", {
                headers: { "X-Shop-Domain": SHOP_DOMAIN }
              })
              .then(function(r) { return r.json(); })
              .then(function(res) {
                var data = res.data || [];
                var match = data.filter(function(p) { return p.handle === h.handle; })[0];
                if (!match && normTitle) {
                  match = data.filter(function(p) { return (p.title || '').trim().toLowerCase() === normTitle; })[0];
                }
                if (!match) return;
                var avg = parseFloat(match.averageRating || 0);
                var cnt = parseInt(match.reviewCount || 0, 10);
                if (avg <= 0 || cnt <= 0) return;
                var el = document.querySelector('[data-rating-handle="' + h.handle + '"]');
                if (!el) return;
                var label = cnt < 1000 ? cnt + ' Reviews' : (cnt / 1000).toFixed(1) + 'K Reviews';
                el.innerHTML = '<span style="color:#FFB503;font-size:11px;">★</span> <span style="font-size:10px;color:#333;">' + avg.toFixed(1) + ' | (' + label + ')</span>';
              })
              .catch(function() {});
            });
          })
          .catch(function (err) { console.error("[BV Search] Best Sellers fetch failed:", err); });
      }

      var inputSelector   = ".wizzy-search-input, .custom-search-header-input";
      isPopupOpen            = false;   /* outer-scope var — shared with handleQuery */
      var lastTriggerInput   = null;
      var closeTimer         = null;
      /* inputDebounceTimer declared in outer scope */
      var closeAnimationMs = 350;
      var openedAt        = 0;
      var _closedByBack   = 0; /* timestamp guard: blocks re-open after back close */

      /* ── Query param helpers for back-button popup persistence ── */
      function _hasPopupParam() {
        return new URLSearchParams(location.search).has('bv-search-popup');
      }
      function _addPopupParam() {
        if (_hasPopupParam()) return;
        var params = new URLSearchParams(location.search);
        params.set('bv-search-popup', '1');
        var url = location.pathname + '?' + params.toString() + location.hash;
        /* Always pushState so pressing Back closes the popup instead of
           leaving the page. The results-page popstate re-fetch is guarded
           by (q === _lastRenderedQ) so a popup-only param change never
           triggers an unwanted re-fetch. */
        try { history.pushState({ bvSearchPopup: true }, '', url); } catch(e) {}
      }
      function _removePopupParam() {
        if (!_hasPopupParam()) return;
        var params = new URLSearchParams(location.search);
        params.delete('bv-search-popup');
        var qs = params.toString();
        var url = location.pathname + (qs ? '?' + qs : '') + location.hash;
        try { history.replaceState(null, '', url); } catch(e) {}
      }

      /* ── Position popup under the triggering input (desktop only) */
      function positionPopupFromInput(inputElement) {
        if (!inputElement || window.innerWidth < 750) return;
        var rect = inputElement.getBoundingClientRect();
        var popupWidth = Math.min(1040, window.innerWidth - 32);
        var maxLeft    = Math.max(16, window.innerWidth - popupWidth - 16);
        popup.style.left  = Math.min(Math.max(16, Math.round(rect.left)), maxLeft) + "px";
        popup.style.width = popupWidth + "px";
      }

      /* ── Open popup */
      function openPopup(inputElement) {
        lastTriggerInput = inputElement || lastTriggerInput;

        /* Block re-open for 500ms after back-button closed the popup */
        if (_closedByBack && Date.now() - _closedByBack < 500) return;

        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        if (isPopupOpen && popup.classList.contains("is-open")) return;

        positionPopupFromInput(lastTriggerInput);

        /* Close any native search modals that may have opened */
        document.querySelectorAll('search-modal details[open]').forEach(function(d) { d.removeAttribute('open'); });

        /* These three lines make the popup visible — must succeed before showDefaultView */
        popup.classList.add("is-open");
        popup.setAttribute("aria-hidden", "false");
        openedAt = Date.now();

        document.documentElement.style.setProperty("--scroll-y", "-" + window.scrollY + "px");
        document.body.classList.add("custom-search-open"); document.documentElement.classList.add("custom-search-open");
        isPopupOpen = true;

        /* Sync mobile popup input with the triggering header input */
        var popupInput = popup.querySelector(".custom-search-header-input");
        var _curVal = lastTriggerInput ? lastTriggerInput.value.trim() : "";
        if (popupInput && lastTriggerInput !== popupInput) {
          popupInput.value = lastTriggerInput ? lastTriggerInput.value : "";
          /* Update clear button visibility */
          var clearBtn = popupInput.parentNode && popupInput.parentNode.querySelector(".custom-search-input-clear");
          if (clearBtn) clearBtn.classList.toggle("is-visible", popupInput.value.length > 0);
        }

        /* Restore view: if input has a query show cached results or re-fetch */
        if (_curVal) {
          /* Always re-run handleQuery so dynamic pills are refetched on reopen */
          try { handleQuery(_curVal); } catch (e) {}
        } else {
          try { showDefaultView(); } catch (e) {}
        }

        /* Ghost-click guard: on mobile the tap that opens the popup fires a
           synthesised click ~0-300ms later at the same screen coordinates.
           By then the popup is visible and a trending keyword may sit exactly
           where the user tapped, triggering an unwanted navigation/event.
           Disabling pointer-events for 400ms blocks both the ghost click and
           any accidental tap during the open animation.                      */
        if (trendingSection) {
          trendingSection.style.pointerEvents = "none";
          setTimeout(function () {
            trendingSection.style.pointerEvents = "";
          }, 400);
        }

        /* Add query param so back-button can close the popup */
        _addPopupParam();
      }

      /* ── Close popup
         keepHistory = true  → preserve ?bv-search-popup in URL (navigating away)
         keepHistory = false → replaceState removes param (manual close) */
      function closePopup(keepHistory) {
        if (!isPopupOpen) return;

        /* Only remove the query param on manual close, not during navigation */
        if (!keepHistory) {
          _removePopupParam();
        }

        /* Clear all input fields — popup + all header inputs */
        var popupInput = popup.querySelector(".custom-search-header-input");
        if (popupInput) {
          popupInput.value = "";
          var clearBtn = popupInput.parentNode && popupInput.parentNode.querySelector(".custom-search-input-clear");
          if (clearBtn) clearBtn.classList.remove("is-visible");
        }
        var headerInputs = document.querySelectorAll(".wizzy-search-input");
        Array.prototype.forEach.call(headerInputs, function (hi) { hi.value = ""; });

        isPopupOpen = false;
        popup.classList.remove("is-open");
        popup.setAttribute("aria-hidden", "true");


        var scrollY = parseInt(
          document.documentElement.style.getPropertyValue("--scroll-y") || "0", 10
        ) * -1;

        if (closeTimer) clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          popup.style.top   = "";
          popup.style.left  = "";
          popup.style.width = "";
          document.body.classList.remove("custom-search-open"); document.documentElement.classList.remove("custom-search-open");
          document.documentElement.style.removeProperty("--scroll-y");
          window.scrollTo(0, scrollY);
          closeTimer = null;
          /* Always clear cached results so stale data is never shown on reopen.
             Input field values are left intact — they are synced separately above. */
          lastQuery = "";
          activeRequestId += 1;
          if (apiResultsEl) { apiResultsEl.style.display = "none"; apiResultsEl.innerHTML = ""; }
          if (topProductsSection) topProductsSection.style.display = "";
          /* Reset any ATC buttons left in a loading state (e.g. persistent
             top-products cards) so they are clickable again on reopen. */
          Array.prototype.forEach.call(
            popup.querySelectorAll(".search-atc.is-loading, .search-atc[data-csr-busy]"),
            function (b) {
              b.dataset.csrBusy = "";
              b.classList.remove("is-loading");
              b.setAttribute("aria-busy", "false");
            }
          );
          try { showDefaultView(); } catch (e) {}
        }, closeAnimationMs);
      }

      /* Expose closePopup globally so the search-results page can close
         the popup when a header form is submitted without going through _goToSearchPage */
      window._bvClosePopup = closePopup;

      /* ── Event listeners ─────────────────────────────────────────── */

      /* Force-close the popup instantly with no animation.
         Used by popstate/pageshow when URL no longer has ?bv-search-popup=1. */
      function _forceClosePopup() {
        _closedByBack = Date.now();
        clearTimeout(debounceTimer);
        clearTimeout(inputDebounceTimer);
        activeRequestId += 1;
        popup.style.transition = "none";
        popup.classList.remove("is-open");
        popup.setAttribute("aria-hidden", "true");
        isPopupOpen = false;
        var _pi = popup.querySelector(".custom-search-header-input");
        if (_pi) {
          _pi.value = "";
          var _cb = _pi.parentNode && _pi.parentNode.querySelector(".custom-search-input-clear");
          if (_cb) _cb.classList.remove("is-visible");
        }
        Array.prototype.forEach.call(
          document.querySelectorAll(".wizzy-search-input"),
          function(i) { i.value = ""; }
        );
        document.body.classList.remove("custom-search-open"); document.documentElement.classList.remove("custom-search-open");
        document.documentElement.style.removeProperty("--scroll-y");
        if (apiResultsEl) { apiResultsEl.style.display = "none"; apiResultsEl.innerHTML = ""; }
        if (topProductsSection) topProductsSection.style.display = "";
        Array.prototype.forEach.call(
          popup.querySelectorAll(".search-atc.is-loading, .search-atc[data-csr-busy]"),
          function (b) {
            b.dataset.csrBusy = "";
            b.classList.remove("is-loading");
            b.setAttribute("aria-busy", "false");
          }
        );
        lastQuery = "";
        requestAnimationFrame(function() {
          requestAnimationFrame(function() { popup.style.transition = ""; });
        });
        try { showDefaultView(); } catch(e) {}
      }

      /* popstate fires on same-document navigations (pushState ↔ back).
         Check classList directly — do not rely on isPopupOpen (can be stale after bfcache). */
      window.addEventListener('popstate', function () {
        if (!_hasPopupParam() && popup.classList.contains("is-open")) {
          _forceClosePopup();
        } else if (_hasPopupParam() && !popup.classList.contains("is-open")) {
          /* Forward navigation restored the popup URL — re-open */
          openPopup(document.querySelector(inputSelector));
        }
      });

      /* If the browser restores this page from bfcache (user pressed back/forward)
         check whether the popup param is in the URL and act accordingly. */
      window.addEventListener("pageshow", function (e) {
        /* Always restore display so the popup can be opened again normally */
        popup.style.display = "";
        /* Clear any stale loading states on "View Product" links left by bfcache */
        if (e.persisted) {
          Array.prototype.forEach.call(
            document.querySelectorAll(".search-atc.is-loading"),
            function (el) { el.classList.remove("is-loading"); }
          );
        }
        if (e.persisted) {
          /* bfcache restore — check if ?bv-search-popup=1 is in URL */
          if (_hasPopupParam()) {
            /* Re-open the popup since user navigated back to this state */
            popup.style.transition = "none";
            /* Re-anchor under the header input — bfcache restored the popup with
               its stale/base `left`, which parks it at the far-left of the page. */
            positionPopupFromInput(lastTriggerInput || document.querySelector(inputSelector));
            popup.classList.add("is-open");
            popup.setAttribute("aria-hidden", "false");
            document.documentElement.style.setProperty("--scroll-y", "-" + window.scrollY + "px");
            document.body.classList.add("custom-search-open"); document.documentElement.classList.add("custom-search-open");
            isPopupOpen = true;
            openedAt = Date.now();
            try { showDefaultView(); } catch(ex) {}
            requestAnimationFrame(function () {
              requestAnimationFrame(function () { popup.style.transition = ""; });
            });
          } else {
            /* No param — force closed */
            _forceClosePopup();
            openedAt = 0;
          }
        } else {
          /* Fresh page load (not bfcache) — auto-open if param present */
          if (_hasPopupParam()) {
            openPopup(document.querySelector(inputSelector));
          }
        }
      });

      /* Clean up body classes if the user navigates away while popup is open.
         pagehide fires BEFORE bfcache takes its snapshot, so hiding the popup
         here means bfcache saves it already closed — no visible flash on back. */
      window.addEventListener("pagehide", function () {
        if (isPopupOpen) {
          popup.style.transition = "none";
          popup.style.display    = "none";
          popup.classList.remove("is-open");
          popup.setAttribute("aria-hidden", "true");
        }
        document.body.classList.remove("custom-search-open"); document.documentElement.classList.remove("custom-search-open");
        document.documentElement.style.removeProperty("--scroll-y");
      });

      /* Open popup on touchstart for instant mobile response */
      document.addEventListener("touchstart", function (event) {
        var input = event.target.closest(inputSelector);
        if (input) openPopup(input);
      }, { passive: true });

      document.addEventListener("focusin", function (event) {
        var input = event.target.closest(inputSelector);
        if (input) openPopup(input);
      });

      document.addEventListener("click", function (event) {
        var input = event.target.closest(inputSelector);
        if (input) openPopup(input);

        /* Intercept any search icon click — open our popup */
        var searchTrigger = event.target.closest(
          'search-modal .modal__toggle, search-modal summary, .header__icon--search,' +
          '.st-searchicon, .st-desktop-searchIcon, .icon-container, #st-searchIcon'
        );
        if (searchTrigger && !event.target.closest(inputSelector)) {
          event.preventDefault();
          event.stopPropagation();
          var details = searchTrigger.closest('details');
          if (details) details.removeAttribute('open');
          var fallbackInput = document.querySelector(inputSelector);
          if (fallbackInput) openPopup(fallbackInput);
        }
      });

      document.addEventListener("input", function (event) {
        var input = event.target.closest(inputSelector);
        if (!input) return;

        /* ── Normalize spaces: collapse runs of 2+ spaces to one ─────
           Preserve cursor position so it doesn't jump to end of word. */
        var raw = input.value;
        var cleaned = raw.replace(/ {2,}/g, " ");   /* collapse multiple spaces */
        if (cleaned !== raw) {
          var cursorPos = input.selectionStart;
          var diff = raw.length - cleaned.length;     /* chars removed before cursor */
          /* Count how many extra chars were removed before the cursor */
          var beforeCursor = raw.slice(0, cursorPos);
          var beforeCleaned = beforeCursor.replace(/ {2,}/g, " ");
          var cursorDiff = beforeCursor.length - beforeCleaned.length;
          input.value = cleaned;
          var newPos = Math.max(0, cursorPos - cursorDiff);
          input.setSelectionRange(newPos, newPos);
        }

        /* Treat whitespace-only input as empty: clear field and show default view */
        if (input.value.trim() === "" && input.value.length > 0) {
          input.value = "";
        }
        /* Enforce 40-word limit */
        var words = input.value.split(/\s+/).filter(function (w) { return w !== ""; });
        if (words.length > 40) {
          input.value = words.slice(0, 40).join(" ");
        }
        /* Show/hide clear button */
        var clearBtn = input.parentNode && input.parentNode.querySelector(".custom-search-input-clear");
        if (clearBtn) clearBtn.classList.toggle("is-visible", input.value.trim().length > 0);
        /* Bidirectional sync: popup input → header inputs and vice versa */
        var popupInput = popup && popup.querySelector(".custom-search-header-input");
        if (input === popupInput) {
          /* Typing in popup → sync to all header inputs */
          var headerInputs = document.querySelectorAll(".wizzy-search-input");
          Array.prototype.forEach.call(headerInputs, function (hi) { hi.value = input.value; });
        } else {
          /* Typing in header → sync to popup input */
          if (popupInput) popupInput.value = input.value;
        }
        /* Debounce query handling — fire immediately only when clearing the field.
           handleQuery trims the value internally, so trailing single space
           is harmless — trimmed value will match lastQuery and skip shimmer. */
        var _inputVal = input.value;
        clearTimeout(inputDebounceTimer);
        if (!_inputVal.trim()) {
          handleQuery("");
        } else {
          handleQuery(_inputVal);
        }
      });

      /* Clear button click — mobile popup only, no page reload */
      document.addEventListener("click", function (event) {
        var clearBtn = event.target.closest(".custom-search-input-clear");
        if (!clearBtn) return;
        event.preventDefault();
        var wrap = clearBtn.parentNode;
        var inp = wrap && wrap.querySelector(".custom-search-header-input");
        if (inp) {
          inp.value = "";
          inp.focus();
          handleQuery("");
        }
        clearBtn.classList.remove("is-visible");
      });



      Array.prototype.forEach.call(
        document.querySelectorAll("[data-custom-search-close]"),
        function (btn) {
          btn.addEventListener("click", function (e) {
            e.preventDefault();
            closePopup();
          });
        }
      );

      /* When a link inside the popup is followed (e.g. a Luxury Categories tile
         or trending keyword), the browser keeps the current — scroll-locked —
         document on screen until the next page paints. On mobile the lock is
         body{position:fixed; top:-scrollY}, so the page behind the popup shows
         white/shifted during that wait. Unlock the body synchronously on the
         click so the popup sits over the real page, not a white flash.
         (ATC buttons are not links and are handled separately.) */
      /* Instantly hide the popup + unlock the page. Used both on in-popup link
         clicks and right before unload (navigation / refresh) so the popup never
         hangs over a blank, scroll-locked page while the next page loads. */
      function _hidePopupForNavigation() {
        var scrollY = parseInt(
          document.documentElement.style.getPropertyValue("--scroll-y") || "0", 10
        ) * -1;
        popup.style.transition = "none";
        popup.style.display = "none";
        popup.classList.remove("is-open");
        popup.setAttribute("aria-hidden", "true");
        isPopupOpen = false;
        document.body.classList.remove("custom-search-open");
        document.documentElement.classList.remove("custom-search-open");
        document.documentElement.style.removeProperty("--scroll-y");
        if (scrollY) window.scrollTo(0, scrollY);
      }

      if (popup) {
        popup.addEventListener("click", function (e) {
          var link = e.target.closest("a[href]");
          if (!link || link.hasAttribute("data-custom-search-close")) return;
          _hidePopupForNavigation();
        }, true);

        /* Refresh or address-bar navigation while the popup is open: drop it
           immediately so the loading screen isn't "popup on white". */
        window.addEventListener("beforeunload", function () {
          if (isPopupOpen) _hidePopupForNavigation();
        });
      }

      /* ATC button inside popup */
      function handleAtcClick(btn) {
        /* Non-reentrant guard. The is-loading class alone is not enough: the
           /cart/add.js success handler used to remove it before closePopup()
           finished, so the 2nd tap of a double-click slipped through and spun
           up a second add + a second cart-suppression observer, which fought
           the theme's drawer teardown and froze the page. csrBusy is set on
           entry and only cleared on a real error — the success path closes the
           popup, which disposes of the button entirely. */
        if (!btn || btn.dataset.csrBusy === "1" || btn.classList.contains("is-loading")) return;
        btn.dataset.csrBusy = "1";
        btn.classList.add("is-loading");
        btn.setAttribute("aria-busy", "true");

        var variantId = btn.getAttribute("data-csr-atc");
        if (!variantId) {
          /* No variant id — navigate to PDP */
          btn.dataset.csrBusy = "";
          btn.classList.remove("is-loading");
          btn.setAttribute("aria-busy", "false");
          var card = btn.closest(".top-products-card, .product-card");
          var pdpHref = card && (card.querySelector("a[href]") || {}).href;
          if (pdpHref) { closePopup(true); window.location.href = pdpHref; }
          return;
        }

        /* Use the theme's native cart drawer (<mini-cart>) exactly like the PDP
           buy-buttons do: ask /cart/add.js to return the rendered drawer
           sections in the same request, then call renderContents(state) which
           replaces the section HTML wholesale and opens the drawer. Replacing
           the HTML is what makes the empty → first-item case work — the old
           SLIDECART_SET_CART path only updated an already-populated drawer, so
           on an empty cart the new item didn't appear until a refresh. */
        var miniCart = document.querySelector("mini-cart");
        var sectionIds = (miniCart && typeof miniCart.getSectionsToRender === "function")
          ? miniCart.getSectionsToRender().map(function (s) { return s.id; })
          : [];

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            sections: sectionIds,
            sections_url: window.location.pathname
          })
        })
        .then(function (r) { return r.json(); })
        .then(function (state) {
          /* Keep is-loading/csrBusy set — the popup closes on success and the
             button is disposed of, so leaving them on prevents any in-flight
             second click from re-entering before closePopup() completes. */
          btn.style.background = "";
          btn.textContent = "ADD TO CART";
          /* keepHistory=false — ATC does NOT navigate, so the popup param must
             be stripped. Leaving ?bv-search-popup=1 in the URL made a later
             popstate (e.g. from cart-drawer history changes) re-open the popup
             and re-apply its scroll lock, freezing the page. */
          closePopup(false);
          /* Render + open the drawer after the popup starts closing so it isn't
             hidden behind the popup. */
          if (miniCart && typeof miniCart.renderContents === "function") {
            miniCart.renderContents(state);
          }
          /* Keep CartJS in sync if the legacy lib is present (no-op otherwise). */
          if (window.CartJS && typeof window.CartJS.getCart === "function") {
            window.CartJS.getCart();
          }
        })
        .catch(function () {
          btn.dataset.csrBusy = "";
          btn.classList.remove("is-loading");
          btn.setAttribute("aria-busy", "false");
          btn.textContent = "ADD TO CART";
        });
      }

      popup.addEventListener("click", function (event) {
        var atc = event.target.closest(".search-atc");
        if (!atc) return;
        /* For <a> View Product links — navigate after loader */
        if (atc.tagName === "A") {
          event.preventDefault();
          var href = atc.href;
          atc.classList.add("is-loading");
          setTimeout(function () {
            closePopup(true);
            window.location.href = href;
          }, 400);
          return;
        }
        /* For ATC buttons */
        handleAtcClick(atc);
      });

      /* ── Navigate to search results — in-page update if already there ── */
      function _goToSearchPage(query) {
        /* If already on the results page, force-close popup instantly (no
           animation delay) so the body is unfixed before _csrReSearch
           runs scroll/fetch. Then update results in-place — no reload. */
        if (window.location.pathname === "/pages/custom-search" && typeof window._csrReSearch === "function") {
          _forceClosePopup();
          _removePopupParam();
          window._csrReSearch(query);
          return;
        }
        /* ── Fire API IMMEDIATELY — before navigation ──────────────────────
           The fetch starts right now. If it resolves before (or shortly
           after) the results page loads, sessionStorage delivers the data
           instantly so the results page skips its own network round-trip. */
        try {
          fetch(
            'https://apps.bellavitaorganic.com/api/v1/search/products?q=' +
              encodeURIComponent(query) + '&limit=20&facets=true',
            { headers: { 'X-Shop-Domain': window.__bvSearchShopDomain, 'X-Session-Id': getSessionId() } }
          )
          .then(function(r) { return r.ok ? r.json() : null; })
          .then(function(json) {
            if (!json) return;
            try {
              sessionStorage.setItem('bvo_prefetch', JSON.stringify({
                q: query, ts: Date.now(), data: json
              }));
            } catch(e) {}
          })
          .catch(function() {});
        } catch(e) {}
        /* keepHistory = true → preserve ?bv-search-popup=1 in history so
           pressing back from the results page re-opens the popup */
        closePopup(true);
        document.body.classList.remove("custom-search-open"); document.documentElement.classList.remove("custom-search-open");
        window.location.href = "/pages/custom-search?q=" + encodeURIComponent(query);
      }

      popup.addEventListener("submit", function (event) {
        /* Search form inside popup — redirect to custom search page */
        var searchForm = event.target.closest("form[action='/pages/custom-search']");
        if (searchForm) {
          event.preventDefault();
          var qVal = searchForm.querySelector("[name='q']");
          var q = qVal ? qVal.value.trim() : "";
          if (!q) return;
          _goToSearchPage(q);
        }
      });

      /* Prevent empty / whitespace-only search form submissions */
      document.addEventListener("submit", function (event) {
        var form = event.target;
        if (!form) return;
        if (form.action && form.action.indexOf("/cart/add") !== -1) return;
        var qInput = form.querySelector("[name='q']");
        if (qInput === null) return;
        /* Always trim the field value so "   " never reaches the server */
        var trimmed = qInput.value.trim();
        if (trimmed === "") {
          event.preventDefault();
          qInput.value = "";
          qInput.focus();
          return;
        }
        /* Strip surrounding whitespace from the submitted query */
        qInput.value = trimmed;
      }, true);

      /* Responsive: close popup on breakpoint change */
      var lastBreakpoint = window.innerWidth >= 750 ? "desktop" : "mobile";
      window.addEventListener("resize", function () {
        var bp = window.innerWidth >= 750 ? "desktop" : "mobile";
        if (bp !== lastBreakpoint) {
          closePopup();
          lastBreakpoint = bp;
        } else if (popup.classList.contains("is-open") && bp === "desktop") {
          positionPopupFromInput(lastTriggerInput);
        }
      });

      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape") { closePopup(); return; }
        if (event.key === "Enter") {
          var input = event.target.closest(inputSelector);
          if (!input) return;
          var q = input.value.trim();
          if (!q) { event.preventDefault(); return; }
          event.preventDefault();
          _goToSearchPage(q);
        }
      });

      /* Intercept clicks on links to /pages/custom-search?q=... inside popup
         (trending keywords, "View all →") — update in-place when already there */
      popup.addEventListener("click", function (event) {
        var link = event.target.closest("a[href*='/pages/custom-search?q=']");
        if (!link) return;
        try {
          var url = new URL(link.href, location.origin);
          var q = (url.searchParams.get("q") || "").trim();
          if (!q) return;
          event.preventDefault();
          _goToSearchPage(q);
        } catch(e) {}
      });

      /* Close popup when clicking outside it (desktop — no overlay) */
      document.addEventListener("click", function (event) {
        if (!isPopupOpen) return;
        /* Guard: ignore stray clicks within 350ms of opening (mobile layout-shift artefact) */
        if (Date.now() - openedAt < 350) return;
        if (popup.contains(event.target)) return;
        /* Also keep open if clicking a trigger input */
        if (event.target.closest(inputSelector)) return;
        closePopup();
      });
    }

    (function() {
      function nukeWizzy() {
        var w = document.querySelector('.wizzy-autocomplete-wrapper');
        if (w) { w.remove(); }
      }
      nukeWizzy();
      var _wizzyObs = new MutationObserver(function(mutations) {
        for (var i = 0; i < mutations.length; i++) {
          for (var j = 0; j < mutations[i].addedNodes.length; j++) {
            var node = mutations[i].addedNodes[j];
            if (node.nodeType === 1 && (node.classList.contains('wizzy-autocomplete-wrapper') || node.querySelector && node.querySelector('.wizzy-autocomplete-wrapper'))) {
              nukeWizzy();
              return;
            }
          }
        }
      });
      _wizzyObs.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(function() { _wizzyObs.disconnect(); }, 15000);
    })();

    /* ── Bootstrap ───────────────────────────────────────────────── */
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initCustomSearchPopup);
    } else {
      initCustomSearchPopup();
    }

    /* ── Fix 7: ATC button loader on the /search results page ──────── */
    if (window.location.pathname === "/search") {
      document.addEventListener("submit", function (e) {
        var form = e.target;
        if (!form || !form.action || form.action.indexOf("/cart/add") === -1) return;
        var btn = form.querySelector('[type="submit"]');
        if (!btn || btn.classList.contains("search-page-atc-loading")) return;
        btn.classList.add("search-page-atc-loading");
        /* Auto-remove as a safety fallback (in case cart drawer/redirect doesn't remove it) */
        setTimeout(function () {
          btn.classList.remove("search-page-atc-loading");
        }, 4000);
      }, true);
    }

    /* ── Custom Search Results Page ──────────────────────────────────
       Renders the full results UI when on /pages/custom-search.
       No template assignment needed — this snippet is already global. */
    if (window.location.pathname === "/pages/custom-search") {
      (function () {

        /* ── Prefetch: consume sessionStorage handoff from previous page first.
           If the user came from popup search, _goToSearchPage already fired
           the API call and stored the result. Use it instantly (zero network).
           Fall back to a fresh fetch if no valid cache is found. ── */
        var _prefetchQ = (new URLSearchParams(window.location.search).get('q') || '').trim();
        var _prefetchPromise = null;
        if (_prefetchQ) {
          var _cached = null;
          try {
            var _raw = sessionStorage.getItem('bvo_prefetch');
            if (_raw) {
              var _entry = JSON.parse(_raw);
              /* Accept cache if query matches and is < 30 seconds old */
              if (_entry && _entry.q === _prefetchQ && (Date.now() - _entry.ts) < 30000) {
                _cached = _entry.data;
              }
              sessionStorage.removeItem('bvo_prefetch');
            }
          } catch(e) {}

          if (_cached) {
            /* Wrap the already-resolved value in a Promise so fetchResults
               can consume it identically to a real fetch promise. */
            _prefetchPromise = Promise.resolve(_cached);
          } else {
            /* No valid cache — fire fresh API call immediately */
            _prefetchPromise = fetch(
              'https://apps.bellavitaorganic.com/api/v1/search/products?q=' +
                encodeURIComponent(_prefetchQ) + '&limit=20&facets=true',
              { headers: { 'X-Shop-Domain': window.__bvSearchShopDomain, 'X-Session-Id': getSessionId() } }
            ).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
          }
        }

        /* ── Inject styles (self-contained — no theme CSS dependency) ── */
        var styleEl = document.createElement("style");
        styleEl.textContent = [
          ".csr-page-wrap{max-width:1200px;margin:0 auto;padding:20px 16px 60px}",
          ".csr-title{font-size:18px;font-weight:700;margin:0 0 18px;color:#212326}",
          ".csr-count{font-size:13px;font-weight:400;color:#888}",
          "#csr-grid{min-height:300px;display:grid;grid-template-columns:repeat(4,1fr);gap:20px}",
          "@media(max-width:1024px){#csr-grid{grid-template-columns:repeat(3,1fr);gap:16px}}",
          "@media(max-width:640px){#csr-grid{grid-template-columns:repeat(2,1fr);gap:12px}}",
          "@keyframes csrShimmer{0%{background-position:-200% 0}100%{background-position:200% 0}}",
          ".csr-sh-card{background:#f9f9f9;border-radius:4px;overflow:hidden;padding-bottom:12px}",
          ".csr-sh-img{width:100%;aspect-ratio:1/1;background:linear-gradient(90deg,#f0f0f0 25%,#e4e4e4 50%,#f0f0f0 75%);background-size:200% 100%;animation:csrShimmer 1.4s ease-in-out infinite}",
          ".csr-sh-line{height:11px;border-radius:3px;margin:10px 12px 0;background:linear-gradient(90deg,#f0f0f0 25%,#e4e4e4 50%,#f0f0f0 75%);background-size:200% 100%;animation:csrShimmer 1.4s ease-in-out infinite}",
          ".csr-sh-line.w70{width:60%}.csr-sh-line.w45{width:40%}",
          ".csr-msg{padding:60px 0;text-align:center;color:#888;font-size:15px;grid-column:1/-1}",
          ".csr-toolbar{display:flex;align-items:center;gap:12px;margin-bottom:12px}",
          ".csr-filter-btn{display:inline-flex;align-items:center;gap:8px;background:#1a1b18;color:#fff;border:none;border-radius:4px;padding:12px 22px;font-size:13px;font-weight:700;letter-spacing:1px;text-transform:uppercase;cursor:pointer}",
          ".csr-filter-badge{display:inline-flex;align-items:center;justify-content:center;min-width:18px;height:18px;border-radius:50%;background:#d72c0d;color:#fff;font-size:10px;font-weight:700;padding:0 4px;line-height:1}",
          ".csr-sort-wrap{position:relative}",
          ".csr-sort-btn{display:inline-flex;align-items:center;gap:6px;background:#fff;color:#212326;border:1px solid #d2d5d9;border-radius:4px;padding:11px 18px;font-size:13px;font-weight:700;letter-spacing:.5px;text-transform:uppercase;cursor:pointer;white-space:nowrap}",
          ".csr-sort-btn svg{flex-shrink:0;width:12px;height:12px}",
          ".csr-sort-menu{display:none;position:absolute;top:calc(100% + 4px);left:0;z-index:100;background:#fff;border:1px solid #e0e0e0;border-radius:4px;box-shadow:0 4px 16px rgba(0,0,0,.1);min-width:220px;padding:6px 0}",
          ".csr-sort-menu.is-open{display:block}",
          ".csr-sort-option{display:block;width:100%;padding:10px 20px;border:none;background:none;text-align:left;font-size:14px;color:#212326;cursor:pointer;white-space:nowrap}",
          ".csr-sort-option:hover{background:#f5f5f5}",
          ".csr-sort-option.is-active{font-weight:700}",
          ".csr-pills-row{display:flex;flex-wrap:wrap;gap:8px;margin-bottom:14px;min-height:0}",
          ".csr-pill{display:inline-flex;align-items:center;gap:5px;background:#f0f0f0;border-radius:20px;padding:5px 12px;font-size:12px;font-weight:600;color:#212326}",
          ".csr-pill-x{cursor:pointer;font-size:13px;color:#888;line-height:1}",
          ".csr-pill-x:hover{color:#d72c0d}"
        ].join("");
        document.head.appendChild(styleEl);

        /* Load theme card CSS for enriched product cards */
        ['template-collection','component-card','component-price','component-product-grid','component-rating','cosmetic-collection'].forEach(function(name) {
          if (!document.querySelector('link[href*="' + name + '"]')) {
            var link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = window.__bvSearchCardCssUrl.replace('component-card.css', name + '.css');
            document.head.appendChild(link);
          }
        });

        /* ── Inject CSS for search results page (JS-injected to bypass section cache) ── */
        (function() {
          var s = document.createElement('style');
          s.textContent =
            '.csr-page-wrap { max-width: var(--page-width); margin: 0 auto; padding: 20px 1.5rem 60px; box-sizing: border-box; }' +
            '@media screen and (min-width:750px) { .csr-page-wrap { padding: 20px 5rem 60px; } }' +
            '.csr-title { font-size: 18px; font-weight: 400; margin: 0 0 18px; color: #212326; }' +
            '.csr-title .csr-title-query { font-weight: 700; }' +
            '#csr-heading .csr-title { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }' +
            '.csr-pill { color: #666; font-weight: 400; }' +
            '.csr-pill-x { color: #999; }' +
            'search-modal .modal__content { display: none !important; }' +
            'search-modal details[open] .modal__content { display: none !important; }' +
            '#csr-grid { min-height:300px; }' +
            '#csr-grid .card-wrapper { width:100%; max-width:100%; overflow:hidden; box-sizing:border-box; }' +
            '#csr-grid use-animate.card { width:100%; display:block; }' +
            '#csr-grid .card__media.media-wrapper { display:block; width:100%; }' +
            '#csr-grid .image-animate { opacity:1 !important; }' +
            '#csr-grid .media--portrait { padding-bottom:125%; }' +
            '.csr-filter-badge { display:none !important; }' +
            '#csr-grid .card-information { display:flex; flex-direction:column; position:relative; width:100%; max-width:100%; box-sizing:border-box; }' +
            '#csr-grid .card-information__wrapper { width:100%; }' +
            '#csr-grid .card-information__button { position:static !important; width:auto !important; height:auto !important; overflow:visible !important; }' +
            '.csr-atc-wrap { width:100%; margin-top:8px; position:relative; z-index:2; }' +
            '.csr-btn { display:block !important; width:100% !important; background:#1a1b18 !important; color:#fff !important; font-size:12px; font-weight:600; letter-spacing:0.5px; text-transform:uppercase; text-align:center; text-decoration:none; border:none !important; padding:14px 0 !important; border-radius:6px; cursor:pointer; box-sizing:border-box; line-height:1.2 !important; position:relative; overflow:hidden; }' +
            '@media screen and (hover:hover) { .csr-btn::after { content:""; position:absolute; top:0; left:-100%; width:100%; height:100%; transform:skew(-15deg); background:linear-gradient(90deg, transparent, rgba(255,255,255,.25), transparent); z-index:1; } .csr-btn:hover::after { animation:csrShine 1s ease; } }' +
            '@keyframes csrShine { to { left:100%; } }' +
            '.csr-btn.is-loading { color:transparent !important; pointer-events:none; }' +
            '.csr-btn.is-loading::after { content:""; position:absolute; top:50%; left:50%; width:16px; height:16px; margin:-8px 0 0 -8px; background:none; border:2px solid rgba(255,255,255,.4); border-top-color:#fff; border-radius:50%; transform:rotate(0deg); animation:csrBtnSpin .6s linear infinite; }' +
            '@keyframes csrBtnSpin { from { transform:rotate(0deg); } to { transform:rotate(360deg); } }' +
            '.csr-btn--soldout { background:#999 !important; cursor:not-allowed; }' +
            '@keyframes csrSpin { to { transform: rotate(360deg); } }' +
            '#csr-scroll-spinner svg { animation: csrSpin 0.8s linear infinite; }' +
            /* Mobile toolbar */
            '.csr-mob-toolbar{display:none}' +
            '.csr-sort-sheet-overlay{display:none;position:fixed;inset:0;z-index:998;background:rgba(0,0,0,.45)}' +
            '.csr-sort-sheet-overlay.is-open{display:block}' +
            '.csr-sort-sheet{display:none;position:fixed;bottom:0;left:0;right:0;z-index:999;background:#fff;border-radius:16px 16px 0 0;box-shadow:0 -4px 30px rgba(0,0,0,.15);padding:0 0 20px;max-height:70vh}' +
            '.csr-sort-sheet.is-open{display:block}' +
            '.csr-sort-sheet-header{display:flex;align-items:center;justify-content:space-between;padding:18px 20px 14px;border-bottom:1px solid #f0f0f0}' +
            '.csr-sort-sheet-title{font-size:16px;font-weight:700;color:#212326}' +
            '.csr-sort-sheet-close{width:32px;height:32px;border-radius:50%;border:1.5px solid #ccc;background:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:16px;color:#666}' +
            '.csr-sort-sheet-list{padding:8px 0}' +
            '.csr-sort-sheet-item{display:block;width:100%;padding:14px 24px;border:none;background:none;text-align:left;font-size:15px;color:#212326;cursor:pointer}' +
            '.csr-sort-sheet-item.is-active{font-weight:700}' +
            '@media(max-width:749px){' +
              '.csr-toolbar{display:none !important}' +
              '.csr-page-wrap{padding-top:0 !important;display:flex !important;flex-direction:column !important}' +
              '.csr-mob-toolbar{display:flex;position:sticky;top:0;z-index:3;background:#fff;border-bottom:1px solid #e0e0e0;border-top:1px solid #e0e0e0;margin:0 -1.5rem 0;order:-1}' +
              '.csr-mob-toolbar-btn{flex:1;display:flex;align-items:center;justify-content:center;gap:8px;padding:18px 0;border:none;background:none;cursor:pointer;font-size:15px;font-weight:400;color:#212326}' +
              '.csr-mob-toolbar-btn svg{width:14px;height:14px;flex-shrink:0}' +
              '.csr-mob-toolbar-divider{width:1px;background:#d0d0d0;margin:10px 0}' +
              '#csr-heading{padding:18px 0 0;order:0}' +
              '#csr-heading .csr-title{font-size:15px;margin-bottom:6px}' +
              '.csr-pills-row{order:1}' +
              '#csr-grid{order:2}' +
              '#csr-scroll-spinner{order:3}' +
              '.csr-btn{padding:10px 0 !important;font-size:11px !important}' +
            '}';
          document.head.appendChild(s);
        })();

        /* ── Inject CSS for the "no matches" empty state + bestsellers grid
              (ported verbatim from the Hydrogen storefront design) ── */
        (function() {
          var s = document.createElement('style');
          s.textContent =
            /* Sizes are in px on purpose: this theme sets html{font-size:62.5%}
               (1rem=10px), which would shrink rem-based type below the design. */
            '#csr-empty-state { width:100%; }' +
            '.csr-empty { text-align:center; padding:0 24px; max-width:520px; margin:0 auto; }' +
            '.csr-empty-searched { font-size:16px; color:#525252; margin:0 0 32px; }' +
            '.csr-empty-searched strong { color:#000; font-weight:700; }' +
            '.csr-empty-illus { display:block; width:210px; height:128px; margin:0 auto 24px; }' +
            '.csr-empty-title { font-size:28px; font-weight:600; color:#000; margin:0 0 12px; line-height:1.25; }' +
            '.csr-empty-desc { font-size:16px; color:#737373; margin:0; line-height:1.5; }' +
            '.csr-bs-section { margin-top:16px; }' +
            '.csr-bs-title { font-size:clamp(22px,3vw,26px); font-weight:400; text-align:center; color:#000; margin:0 0 24px; }' +
            '.csr-bs-divider { border:none; border-top:1px solid #212336; margin:0 0 24px; }' +
            '.csr-bs-divider--top { margin-top:24px; }' +
            '.csr-bs-grid { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:16px; }' +
            '@media (min-width:768px) { .csr-bs-grid { grid-template-columns:repeat(3,minmax(0,1fr)); gap:24px; } }' +
            '@media (min-width:1024px) { .csr-bs-grid { grid-template-columns:repeat(4,minmax(0,1fr)); gap:30px; } }' +
            '.csr-bs-card { position:relative; display:flex; flex-direction:column; min-width:0; }' +
            '.csr-bs-card-image { position:relative; background:#f5f5f5; overflow:hidden; margin-bottom:16px; aspect-ratio:4/5; }' +
            '.csr-bs-card-image img { width:100%; height:100%; object-fit:contain; transition:transform 0.3s ease-in-out; }' +
            '.csr-bs-card:hover .csr-bs-card-image img { transform:scale(1.05); }' +
            '.csr-bs-badge { position:absolute; top:10px; left:10px; padding:3px 10px; font-size:11px; font-weight:600; text-transform:uppercase; letter-spacing:0.5px; border-radius:2px; z-index:2; }' +
            '.csr-bs-badge.bestseller { background:rgb(216 162 115); color:#fff; }' +
            '.csr-bs-badge.sale { background:rgb(113 190 169); color:#fff; top:unset; left:unset; bottom:10px; right:10px; width:max-content; height:fit-content; }' +
            '.csr-bs-type { font-size:11px; line-height:1; font-weight:400; text-transform:uppercase; letter-spacing:1px; color:#737373; margin-bottom:6px; }' +
            '.csr-bs-card-title { font-size:15px; font-weight:500; color:#000; margin:0 0 8px; line-height:1.4; display:-webkit-box; -webkit-box-orient:vertical; -webkit-line-clamp:1; line-clamp:1; overflow:hidden; }' +
            '.csr-bs-card-title a { color:inherit; text-decoration:none; }' +
            '.csr-bs-card-title a:hover { text-decoration:underline; }' +
            '.csr-bs-rating { display:flex; align-items:center; gap:6px; margin-bottom:8px; font-size:14px; white-space:nowrap; flex-wrap:nowrap; overflow:hidden; }' +
            '.csr-bs-rating svg { flex-shrink:0; width:16px; height:16px; }' +
            '.csr-bs-price { display:flex; align-items:center; gap:8px; margin-bottom:12px; }' +
            '.csr-bs-price-sale { font-size:16px; font-weight:500; color:#000; }' +
            '.csr-bs-price-regular { font-size:16px; color:#a3a3a3; text-decoration:line-through; }' +
            '.csr-bs-card .csr-btn { margin-top:auto; }';
          document.head.appendChild(s);
        })();

        /* Magnifier illustration (base64, ported from Hydrogen) */
        var CSR_EMPTY_ILLUS = "data:image/svg+xml;base64,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";

        /* ── Toggle the filter/sort/pills chrome (hidden in the empty state) ── */
        function _csrToggleChrome(show) {
          var wrap = document.querySelector(".csr-page-wrap");
          if (!wrap) return;
          [".csr-toolbar", ".csr-mob-toolbar", ".csr-pills-row"].forEach(function(sel) {
            var el = wrap.querySelector(sel);
            if (el) el.style.display = show ? "" : "none";
          });
          if (!show) {
            var sp = document.getElementById("csr-scroll-spinner");
            if (sp) sp.style.display = "none";
          }
        }

        /* ── "No matches" empty state with a Bestsellers grid (Wizzy-style) ── */
        function renderNoResults(query, grid, heading) {
          heading.innerHTML = '<h1 class="csr-title">&nbsp;</h1>';  /* reserve the line — blanking it collapses the box and shifts the page */
          _csrToggleChrome(false);

          var wrap = grid.parentNode;
          var es = document.getElementById("csr-empty-state");
          if (!es) {
            es = document.createElement("div");
            es.id = "csr-empty-state";
            wrap.insertBefore(es, grid);
          }
          es.style.display = "";

          /* Tear down the results grid completely. Clearing innerHTML removes the
             shimmer placeholders showShimmer() injected before the API answered;
             disconnecting the flex-guard MutationObserver lets display:none stick
             (otherwise it forces the empty grid back to flex and the stale shimmer
             stays visible, looping forever). Also kill the infinite-scroll
             observer + its sentinel/spinner so nothing reappends. */
          if (grid._csrFlexGuard) { grid._csrFlexGuard.disconnect(); grid._csrFlexGuard = null; }
          if (_csrScrollObserver) { _csrScrollObserver.disconnect(); _csrScrollObserver = null; }
          var _oldSentinel = document.getElementById("csr-scroll-sentinel");
          if (_oldSentinel) _oldSentinel.remove();
          var _oldSpinner = document.getElementById("csr-scroll-spinner");
          if (_oldSpinner) _oldSpinner.remove();
          grid.innerHTML = "";
          grid.style.display = "none";

          var searched = !!(query && query.trim().length);
          es.innerHTML =
            '<div class="csr-empty">' +
              (searched ? '<p class="csr-empty-searched">You searched for <strong>' + escH(query) + '</strong></p>' : '') +
              '<img class="csr-empty-illus" src="' + CSR_EMPTY_ILLUS + '" alt="search_empty" aria-hidden="true" width="180" height="110">' +
              '<h2 class="csr-empty-title">' + (searched ? 'We couldn\'t find any matches!' : 'Search for something') + '</h2>' +
              '<p class="csr-empty-desc">' + (searched ? 'Please check the spelling or try searching for something else.' : 'Try a product name, fragrance note, or browse our collections to find what you\'re looking for.') + '</p>' +
            '</div>' +
            '<section class="csr-bs-section" id="csr-bs-section" style="display:none;">' +
              '<hr class="csr-bs-divider">' +
              '<h2 class="csr-bs-title">Check out our Bestsellers</h2>' +
              '<hr class="csr-bs-divider csr-bs-divider--top">' +
              '<div class="csr-bs-grid" id="csr-bs-grid"></div>' +
            '</section>';

          var bsGrid = document.getElementById("csr-bs-grid");
          if (bsGrid) {
            bsGrid.removeEventListener("click", _csrGridClickHandler);
            bsGrid.addEventListener("click", _csrGridClickHandler);
          }
          _loadBestsellers(bsGrid, document.getElementById("csr-bs-section"));
        }

        function _buildBsCard(p) {
          var v = (p.variants && p.variants[0]) || {};
          var price = parseFloat(v.price) || 0;
          var compareAt = parseFloat(v.compare_at_price) || 0;
          var discount = (compareAt && compareAt > price) ? Math.round(((compareAt - price) / compareAt) * 100) : 0;
          var img = (p.images && p.images[0] && p.images[0].src) ||
                    (p.featured_image && (p.featured_image.src || p.featured_image)) || "";
          var sep = img.indexOf("?") !== -1 ? "&" : "?";
          var handle = p.handle || "";
          var url = "/products/" + encodeURIComponent(handle);
          var title = p.title || "";
          var vendor = (p.vendor || "").trim() || "PERFUME";
          var variantId = v.id || "";
          var single = !!(p.variants && p.variants.length === 1);

          var atc = (variantId && single)
            ? '<button type="button" class="csr-btn" data-csr-atc="' + variantId + '">ADD TO CART</button>'
            : '<a href="' + url + '" class="csr-btn">ADD TO CART</a>';

          return '<div class="csr-bs-card">' +
            '<a href="' + url + '"><div class="csr-bs-card-image">' +
              (img ? '<img src="' + escH(img) + sep + 'width=500" alt="' + escH(title) + '" width="400" height="500" loading="lazy">' : '') +
              '<span class="csr-bs-badge bestseller">BESTSELLER</span>' +
              (discount > 0 ? '<span class="csr-bs-badge sale">' + discount + '% OFF</span>' : '') +
            '</div></a>' +
            '<div class="csr-bs-type">' + escH(vendor) + '</div>' +
            '<h3 class="csr-bs-card-title"><a href="' + url + '">' + escH(title) + '</a></h3>' +
            '<div class="csr-bs-rating" data-rating-handle="' + escH(handle) + '" style="visibility:hidden;"></div>' +
            '<div class="csr-bs-price"><span class="csr-bs-price-sale">₹' + price.toLocaleString("en-IN") + '</span>' +
              (discount > 0 ? '<span class="csr-bs-price-regular">₹' + compareAt.toLocaleString("en-IN") + '</span>' : '') +
            '</div>' +
            atc +
          '</div>';
        }

        function _enrichBsRating(p) {
          var h = p.handle || "";
          var q = (p.title || h.replace(/-/g, " ")).trim();
          var normTitle = (p.title || "").trim().toLowerCase();
          fetch(SEARCH_API_BASE + "/api/v1/search/products?q=" + encodeURIComponent(q) + "&limit=20", {
            headers: { "X-Shop-Domain": SHOP_DOMAIN_CSR, "X-Session-Id": getSessionId() }
          })
          .then(function(r) { return r.json(); })
          .then(function(res) {
            var data = res.data || [];
            var m = data.filter(function(x) { return x.handle === h; })[0];
            if (!m && normTitle) m = data.filter(function(x) { return (x.title || "").trim().toLowerCase() === normTitle; })[0];
            if (!m) return;
            var avg = parseFloat(m.averageRating || 0);
            var cnt = parseInt(m.reviewCount || 0, 10);
            if (avg <= 0 || cnt <= 0) return;
            var el = document.querySelector('.csr-bs-rating[data-rating-handle="' + h + '"]');
            if (!el) return;
            var label = cnt < 1000 ? ('(' + cnt + ' Reviews)') : ('(' + (cnt / 1000).toFixed(1) + 'K Reviews)');
            el.innerHTML =
              '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="14" height="14"><path d="M12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26Z" fill="#FFB503"></path></svg>' +
              '<span>' + avg.toFixed(1) + ' |</span>' +
              '<svg viewBox="0 0 18 18" height="14" width="14"><polygon fill="#005eff" points="9,16 7.1,16.9 5.8,15.2 3.7,15.1 3.4,13 1.5,12 2.2,9.9 1.1,8.2 2.6,6.7 2.4,4.6 4.5,4 5.3,2 7.4,2.4 9,1.1 10.7,2.4 12.7,2 13.6,4 15.6,4.6 15.5,6.7 17,8.2 15.9,9.9 16.5,12 14.7,13 14.3,15.1 12.2,15.2 10.9,16.9"></polygon><polygon fill="#FFFFFF" points="13.1,7.3 12.2,6.5 8.1,10.6 5.9,8.5 5,9.4 8,12.4"></polygon></svg>' +
              '<span>' + label + '</span>';
            el.style.visibility = "visible";
          })
          .catch(function() {});
        }

        function _loadBestsellers(bsGrid, section) {
          if (!bsGrid) return;
          fetch("/collections/bestsellers/products.json?limit=8")
          .then(function(r) { if (!r.ok) throw new Error(r.status); return r.json(); })
          .then(function(res) {
            var products = ((res && res.products) || []).filter(function(p) { return !csrIsHidden(p); });
            if (!products.length) return;
            if (section) section.style.display = "";
            bsGrid.innerHTML = products.map(function(p) { return _buildBsCard(p); }).join("");
            products.forEach(function(p) { _enrichBsRating(p); });
          })
          .catch(function() {});
        }

        /* ── Find page content container and replace it ── */
        function mountUI() {
          /* If the section already rendered .csr-page-wrap with shimmer,
             reuse it directly — no DOM wipe needed, no flicker. */
          var existingWrap = document.querySelector(".csr-page-wrap");
          if (existingWrap && document.getElementById("csr-grid")) {
            /* Ensure page-width class is present for proper alignment */
            if (!existingWrap.classList.contains('page-width')) existingWrap.classList.add('page-width');
            /* Rescue filter panel/overlay before anything else */
            var _ep = document.getElementById("csrf-popup");
            var _eo = document.getElementById("csrf-overlay");
            if (_ep) document.body.appendChild(_ep);
            if (_eo) document.body.appendChild(_eo);

            /* Remove any sibling elements inside the host that aren't
               .csr-page-wrap (e.g. extra scripts/styles from the section) */
            var host = existingWrap.parentNode;
            if (host) {
              var _hostAssets = host.querySelectorAll("style, link[rel='stylesheet']");
              Array.prototype.forEach.call(_hostAssets, function (s) {
                document.head.appendChild(s);
              });
            }

            /* Hold the grid's server-rendered height before anything swaps its
               children. The section renders exactly 8 shimmer cards, so a search
               returning fewer products collapsed the grid and pulled the page up
               into view — measured as a tight cluster of ~0.4 CLS on ~30% of
               visits after the template assignment removed the bigger whole-page
               shift. Only the floor needs holding: growth pushes content
               off-screen, which does not count, while shrinkage pulls it in.

               offsetHeight is read once, after paint, rather than hard-coding a
               per-breakpoint min-height — the shimmer is 2 rows on desktop and 4
               on mobile, and a magic number would drift out of step with the CSS.
               The trade-off is accepted whitespace under a short result list,
               which is preferable to the page moving. */
            var _csrGrid = document.getElementById("csr-grid");
            if (_csrGrid && !_csrGrid.style.minHeight) {
              var _csrH = _csrGrid.offsetHeight;
              if (_csrH > 0) _csrGrid.style.minHeight = _csrH + "px";
            }
            bootSearchPage();
            return;
          }

          var host =
            document.getElementById("MainContent") ||
            document.querySelector("main") ||
            document.querySelector("[role='main']") ||
            document.getElementById("PageContainer") ||
            document.querySelector(".main-content") ||
            document.querySelector(".page-width");

          if (!host) return;

          /* Rescue filter panel, overlay AND all <style> blocks before wiping host */
          var _existingPanel   = document.getElementById("csrf-popup");
          var _existingOverlay = document.getElementById("csrf-overlay");
          if (_existingPanel)   document.body.appendChild(_existingPanel);
          if (_existingOverlay) document.body.appendChild(_existingOverlay);
          /* Move every <style> and <link> inside the host to <head> so CSS survives the wipe */
          var _hostAssets = host.querySelectorAll("style, link[rel='stylesheet']");
          Array.prototype.forEach.call(_hostAssets, function (s) {
            document.head.appendChild(s);
          });

          var wrap = document.createElement("div");
          wrap.className = "csr-page-wrap page-width";
          wrap.innerHTML =
            '<div id="csr-heading"><h1 class="csr-title">&nbsp;</h1></div>' +
            '<div class="csr-toolbar">' +
              '<div style="position:relative;">' +
                '<button class="csr-filter-btn" id="csr-filter-btn">' +
                  'FILTERS +' +
                  '<span class="csr-filter-badge" id="csr-filter-badge" style="display:none;">0</span>' +
                '</button>' +
              '</div>' +
              '<div class="csr-sort-wrap" id="csr-sort-wrap">' +
                '<button class="csr-sort-btn" id="csr-sort-btn" type="button">' +
                  'SORT BY : <span id="csr-sort-label">RELEVANCE</span>' +
                  '<svg viewBox="0 0 12 8" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 1 6 6 11 1"/></svg>' +
                '</button>' +
                '<div class="csr-sort-menu" id="csr-sort-menu">' +
                  '<button class="csr-sort-option is-active" data-sort="relevance">Relevance</button>' +
                  '<button class="csr-sort-option" data-sort="price-high">Price: High to Low</button>' +
                  '<button class="csr-sort-option" data-sort="price-low">Price: Low to High</button>' +
                  '<button class="csr-sort-option" data-sort="discount">Discount : High to Low</button>' +
                  '<button class="csr-sort-option" data-sort="newest">Newest First</button>' +
                  '<button class="csr-sort-option" data-sort="oldest">Oldest First</button>' +
                  '<button class="csr-sort-option" data-sort="bestseller">Best Seller</button>' +
                '</div>' +
              '</div>' +
            '</div>' +
            '<div class="csr-mob-toolbar" id="csr-mob-toolbar">' +
              '<button class="csr-mob-toolbar-btn" id="csr-mob-sort-btn" type="button">' +
                '<svg viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M5 3v12M5 15l-3-3M5 15l3-3M13 15V3M13 3l-3 3M13 3l3 3"/></svg>' +
                'Sort By' +
              '</button>' +
              '<div class="csr-mob-toolbar-divider"></div>' +
              '<button class="csr-mob-toolbar-btn" id="csr-mob-filter-btn" type="button">' +
                '<svg viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polygon points="1 1 17 1 10 9.5 10 15 8 17 8 9.5"/></svg>' +
                'Filters' +
              '</button>' +
            '</div>' +
            '<div class="csr-sort-sheet-overlay" id="csr-sort-sheet-overlay"></div>' +
            '<div class="csr-sort-sheet" id="csr-sort-sheet">' +
              '<div class="csr-sort-sheet-header">' +
                '<span class="csr-sort-sheet-title">Sort By</span>' +
                '<button class="csr-sort-sheet-close" id="csr-sort-sheet-close" type="button">&#x2715;</button>' +
              '</div>' +
              '<div class="csr-sort-sheet-list" id="csr-sort-sheet-list">' +
                '<button class="csr-sort-sheet-item is-active" data-sort="relevance">Relevance</button>' +
                '<button class="csr-sort-sheet-item" data-sort="price-high">Price: High to Low</button>' +
                '<button class="csr-sort-sheet-item" data-sort="price-low">Price: Low to High</button>' +
                '<button class="csr-sort-sheet-item" data-sort="discount">Discount : High to Low</button>' +
                '<button class="csr-sort-sheet-item" data-sort="newest">Newest First</button>' +
                '<button class="csr-sort-sheet-item" data-sort="oldest">Oldest First</button>' +
                '<button class="csr-sort-sheet-item" data-sort="bestseller">Best Seller</button>' +
              '</div>' +
            '</div>' +
            '<div class="csr-pills-row" id="csr-active-pills"></div>' +
            '<ul id="csr-grid" class="product-grid grid grid--2-col grid--3-col-tablet grid--4-col-desktop" role="list"></ul>';

          /* Clear page content and mount our UI */
          host.innerHTML = "";
          host.appendChild(wrap);

          bootSearchPage();
        }

        function escH(v) {
          return String(v || "")
            .replace(/&/g, "&amp;").replace(/</g, "&lt;")
            .replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
        }

        function resizeImg(url) {
          if (!url) return "";
          try {
            return url
              .replace(/_(\d+)x(\d*)\./, ".")
              .replace(/\.(jpg|jpeg|png|webp|gif)(\?.*)?$/i, function (m, ext, qs) {
                return "_360x." + ext + (qs || "");
              });
          } catch(e) { return url; }
        }

        var csrActiveRid = 0;
        var SEARCH_API_BASE = "https://apps.bellavitaorganic.com";
        var SHOP_DOMAIN_CSR = window.__bvSearchShopDomain;
        function getSessionId() {
          try {
            var key = 'bv_search_session_id';
            var id = sessionStorage.getItem(key);
            if (!id) {
              id = (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function')
                ? crypto.randomUUID()
                : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = (Math.random() * 16) | 0;
                    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
                  });
              sessionStorage.setItem(key, id);
            }
            return id;
          } catch(e) { return ''; }
        }
        var LIMIT = 20;
        var _csrCurrentPage = 1;
        var _csrTotalPages = 1;
        var _csrLoadingMore = false;
        var _csrCurrentQuery = '';
        var _csrCurrentSort = 'relevance';
        var _csrAllItems = [];
        var _csrScrollObserver = null;

        var _sortKeyToApi = {
          'relevance':  'relevance',
          'price-high': 'price_desc',
          'price-low':  'price_asc',
          'newest':     'newest',
          'oldest':     'relevance',
          'discount':   'relevance',
          'bestseller': 'relevance'
        };

        /* Tags that mark a product as hidden from all search surfaces */
        var CSR_HIDDEN_TAGS = ["product-hide", "hidden", "skip-collection"];
        function csrIsHidden(p) {
          var tags = p.tags || [];
          /* tags may be an array or a comma-separated string */
          if (typeof tags === "string") tags = tags.split(",");
          for (var _t = 0; _t < tags.length; _t++) {
            var tag = (tags[_t] + "").trim().toLowerCase();
            for (var _h = 0; _h < CSR_HIDDEN_TAGS.length; _h++) {
              if (tag === CSR_HIDDEN_TAGS[_h]) return true;
            }
          }
          return false;
        }

        function showShimmer(grid) {
          var html = "";
          for (var i = 0; i < 8; i++) {
            html +=
              '<li class="grid__item">' +
                '<div class="csr-sh-card"><div class="csr-sh-img"></div>' +
                  '<div class="csr-sh-line w70"></div>' +
                  '<div class="csr-sh-line w45"></div>' +
                '</div>' +
              '</li>';
          }
          grid.innerHTML = html;
        }

        var csrRenderGen = 0;

        function _csrGridClickHandler(e) {
          var atcBtn = e.target.closest ? e.target.closest("[data-csr-atc]") : null;
          if (atcBtn) { e.preventDefault(); e.stopPropagation(); addToCart(atcBtn, atcBtn.getAttribute("data-csr-atc")); return; }

          /* Safety net: a lazy button clicked before it finished resolving.
             Resolve the variant now — single → add to cart, multiple → product page. */
          var lazyBtn = e.target.closest ? e.target.closest("[data-csr-lazy]") : null;
          if (lazyBtn) {
            e.preventDefault(); e.stopPropagation();
            var handle = lazyBtn.getAttribute("data-csr-lazy");
            lazyBtn.classList.add("is-loading");
            fetch("/products/" + encodeURIComponent(handle) + ".json?fields=id,variants")
            .then(function(r) { if (!r.ok) throw new Error(r.status); return r.json(); })
            .then(function(data) {
              var variants = (data.product && data.product.variants) || [];
              if (variants.length === 1) {
                lazyBtn.removeAttribute("data-csr-lazy");
                lazyBtn.setAttribute("data-csr-atc", variants[0].id);
                lazyBtn.classList.remove("is-loading");
                addToCart(lazyBtn, variants[0].id);
              } else {
                window.location.href = "/products/" + handle;
              }
            })
            .catch(function() { lazyBtn.classList.remove("is-loading"); window.location.href = "/products/" + handle; });
          }
        }

        /* Resolve lazy ATC buttons (products the search API returned without a
           variant id) in the background, so each upgrades to the correct button
           without needing a click: single-variant → real Add to cart,
           multi-variant → View products link. No-op when there are none. */
        function _csrResolveLazyButtons(grid) {
          if (!grid) return;
          var lazyBtns = grid.querySelectorAll("[data-csr-lazy]");
          Array.prototype.forEach.call(lazyBtns, function(btn) {
            var handle = btn.getAttribute("data-csr-lazy");
            fetch("/products/" + encodeURIComponent(handle) + ".json?fields=id,variants")
            .then(function(r) { if (!r.ok) throw new Error(r.status); return r.json(); })
            .then(function(data) {
              var variants = (data.product && data.product.variants) || [];
              if (variants.length === 1) {
                btn.removeAttribute("data-csr-lazy");
                btn.setAttribute("data-csr-atc", variants[0].id);
              } else if (variants.length > 1) {
                var a = document.createElement("a");
                a.href = "/products/" + handle;
                a.className = btn.className;
                a.textContent = "View products";
                if (btn.parentNode) btn.parentNode.replaceChild(a, btn);
              }
            })
            .catch(function() { /* leave as-is; click handler will resolve on demand */ });
          });
        }

        function renderCards(items, query, grid, heading, facets, pagination) {
          var gen = ++csrRenderGen;
          items = Array.prototype.filter.call(items || [], function(p) { return !csrIsHidden(p); });

          if (!items || !items.length) {
            renderNoResults(query, grid, heading);
            return;
          }
          /* Results exist — tear down any prior empty state and restore chrome. */
          var _es = document.getElementById("csr-empty-state");
          if (_es) _es.style.display = "none";
          grid.style.display = "";
          _csrToggleChrome(true);

          var totalCount = (pagination && pagination.total) || items.length;
          heading.innerHTML =
            '<h1 class="csr-title">' + totalCount + ' Results found for &ldquo;<strong class="csr-title-query">' + escH(query) + '</strong>&rdquo;:</h1>';

          /* ── Pagination state ── */
          _csrCurrentPage = (pagination && pagination.page) || 1;
          _csrTotalPages = (pagination && pagination.totalPages) || 1;
          _csrCurrentQuery = query;
          _csrAllItems = items.slice();
          _csrLoadingMore = false;

          /* ── Populate filter dropdown from loaded items + API facets ── */
          if (window.csrFilter && typeof window.csrFilter.populate === 'function') {
            window.csrFilter.populate(items, facets);
          }

          /* ── Build all cards from API data — no Shopify fetches needed ── */
          forceFlexGrid(grid);
          grid.innerHTML = items.map(function(p, idx) {
            var v0 = (p.variants && p.variants[0]) || {};
            var price = parseFloat(v0.price || p.minPrice || 0);
            var tags = p.tags || [];
            if (typeof tags === 'string') tags = tags.split(',');
            tags = tags.map(function(t){ return (t+'').trim(); }).filter(Boolean);
            var pt = (p.productType || '').trim();
            var inStock = !(p.totalInventory != null && p.totalInventory <= 0);

            var sizes = [];
            (p.variants || []).forEach(function(v) {
              var t = (v.title || '').trim();
              if (t && t.toLowerCase() !== 'default title' && t.length <= 40 && sizes.indexOf(t) === -1) {
                sizes.push(t); return;
              }
              (v.selectedOptions || []).forEach(function(opt) {
                var val = (opt.value || '').trim();
                if (!val || val.toLowerCase() === 'default title' || val.length > 40) return;
                if (sizes.indexOf(val) === -1) sizes.push(val);
              });
            });

            var compareAt = parseFloat(v0.compareAtPrice || 0);
            var discount = (compareAt && compareAt > price) ? Math.round(((compareAt - price) / compareAt) * 100) : 0;
            var publishedAt = p.publishedAt || '';
            var avgRating = parseFloat(p.averageRating || 0);
            var isBestseller = (p.label && p.label.indexOf('Bestseller') !== -1) ? '1' : '0';

            return '<li class="grid__item csr-card"' +
              ' data-handle="' + escH(p.handle || '') + '"' +
              ' data-price="' + price + '"' +
              ' data-discount="' + discount + '"' +
              ' data-date="' + escH(publishedAt) + '"' +
              ' data-rating="' + avgRating + '"' +
              ' data-bestseller="' + isBestseller + '"' +
              ' data-pos="' + idx + '"' +
              ' data-tags="' + escH(tags.join('|')) + '"' +
              ' data-type="' + escH(pt) + '"' +
              ' data-avail="' + inStock + '"' +
              ' data-sizes="' + escH(sizes.join('|').toLowerCase()) + '">' +
              _buildCard(p) +
            '</li>';
          }).join('');

          document.dispatchEvent(new CustomEvent("theme:section:load", { bubbles: true }));
          if (window.csrFilter && typeof window.csrFilter.stampCards === 'function') {
            window.csrFilter.stampCards();
          }
          /* Re-apply any active filters that survived the populate() rebuild
             (e.g. after a sort re-fetch) so the freshly rendered cards are
             hidden/shown to match the user's selections — and the chips reflect
             real state. No-op when nothing is selected. */
          if (window.csrFilter && typeof window.csrFilter._applyFilters === 'function') {
            window.csrFilter._applyFilters();
          }
          /* Keep the rendered order in sync with the active sort selection
             (server order may not match for client-only sort keys). Always run
             — even for 'relevance' — so sold-out products are deprioritised to
             the bottom in every view. */
          if (typeof window._csrClientSort === 'function') {
            window._csrClientSort(_csrCurrentSort || 'relevance');
          }
          Array.prototype.forEach.call(grid.querySelectorAll('.media--portrait > img, .media--portrait > lazy-image'), function(el) {
            el.style.setProperty('object-fit', 'contain', 'important');
            el.style.setProperty('padding', '6%', 'important');
          });

          /* ── ATC click delegation ── */
          grid.removeEventListener("click", _csrGridClickHandler);
          grid.addEventListener("click", _csrGridClickHandler);

          /* Upgrade any lazy ATC buttons from partial API data. */
          _csrResolveLazyButtons(grid);

          /* ── Infinite scroll sentinel ── */
          _setupScrollObserver(grid, gen);
        }

        function _appendCards(items, grid) {
          items = Array.prototype.filter.call(items || [], function(p) { return !csrIsHidden(p); });
          if (!items.length) return;

          _csrAllItems = _csrAllItems.concat(items);

          /* Re-populate filters with all loaded items */
          if (window.csrFilter && typeof window.csrFilter.populate === 'function') {
            window.csrFilter.populate(_csrAllItems);
          }

          /* Continue data-pos numbering from the cards already in the grid so
             relevance order (and re-sorts) stay correct after infinite scroll. */
          var _posBase = grid.querySelectorAll('.csr-card').length;
          var fragment = document.createDocumentFragment();
          items.forEach(function(p, _i) {
            var v0 = (p.variants && p.variants[0]) || {};
            var price = parseFloat(v0.price || p.minPrice || 0);
            var tags = p.tags || [];
            if (typeof tags === 'string') tags = tags.split(',');
            tags = tags.map(function(t){ return (t+'').trim(); }).filter(Boolean);
            var pt = (p.productType || '').trim();
            var inStock = !(p.totalInventory != null && p.totalInventory <= 0);

            var sizes = [];
            (p.variants || []).forEach(function(v) {
              var t = (v.title || '').trim();
              if (t && t.toLowerCase() !== 'default title' && t.length <= 40 && sizes.indexOf(t) === -1) {
                sizes.push(t); return;
              }
              (v.selectedOptions || []).forEach(function(opt) {
                var val = (opt.value || '').trim();
                if (!val || val.toLowerCase() === 'default title' || val.length > 40) return;
                if (sizes.indexOf(val) === -1) sizes.push(val);
              });
            });

            var compareAt = parseFloat(v0.compareAtPrice || 0);
            var discount = (compareAt && compareAt > price) ? Math.round(((compareAt - price) / compareAt) * 100) : 0;

            var li = document.createElement('li');
            li.className = 'grid__item csr-card';
            li.setAttribute('data-handle', p.handle || '');
            li.setAttribute('data-price', price);
            li.setAttribute('data-discount', discount);
            li.setAttribute('data-date', p.publishedAt || '');
            li.setAttribute('data-rating', parseFloat(p.averageRating || 0));
            li.setAttribute('data-bestseller', (p.label && p.label.indexOf('Bestseller') !== -1) ? '1' : '0');
            li.setAttribute('data-tags', tags.join('|'));
            li.setAttribute('data-type', pt);
            li.setAttribute('data-avail', inStock);
            li.setAttribute('data-sizes', sizes.join('|').toLowerCase());
            li.setAttribute('data-pos', _posBase + _i);
            li.innerHTML = _buildCard(p);
            fragment.appendChild(li);
          });

          grid.appendChild(fragment);

          if (window.csrFilter && typeof window.csrFilter.stampCards === 'function') {
            window.csrFilter.stampCards();
          }
          /* Re-apply active filters to the newly appended cards so infinite
             scroll doesn't surface products that don't match the selection. */
          if (window.csrFilter && typeof window.csrFilter._applyFilters === 'function') {
            window.csrFilter._applyFilters();
          }
          /* Re-sort so appended cards slot into the active sort order. Always
             run — even for 'relevance' — so newly appended sold-out products
             also sink to the bottom. */
          if (typeof window._csrClientSort === 'function') {
            window._csrClientSort(_csrCurrentSort || 'relevance');
          }

          /* Upgrade any lazy ATC buttons on the appended cards too. */
          _csrResolveLazyButtons(grid);
          Array.prototype.forEach.call(grid.querySelectorAll('.media--portrait > img, .media--portrait > lazy-image'), function(el) {
            el.style.setProperty('object-fit', 'contain', 'important');
            el.style.setProperty('padding', '6%', 'important');
          });
        }

        function _loadNextPage(grid, gen) {
          if (_csrLoadingMore || _csrCurrentPage >= _csrTotalPages) return;
          _csrLoadingMore = true;

          var nextPage = _csrCurrentPage + 1;

          /* Show loading spinner */
          var spinner = document.getElementById('csr-scroll-spinner');
          if (spinner) spinner.style.display = 'flex';

          var apiSort = _sortKeyToApi[_csrCurrentSort] || 'relevance';
          fetch(SEARCH_API_BASE + "/api/v1/search/products?q=" + encodeURIComponent(_csrCurrentQuery) + "&limit=" + LIMIT + "&page=" + nextPage + "&sort=" + apiSort + "&facets=false", {
            headers: { "X-Shop-Domain": SHOP_DOMAIN_CSR, "X-Session-Id": getSessionId() }
          })
          .then(function(r) { if (!r.ok) throw new Error(r.status); return r.json(); })
          .then(function(res) {
            if (gen !== csrRenderGen) return;
            if (res && res.success && res.data && res.data.length) {
              _csrCurrentPage = nextPage;
              if (res.pagination) _csrTotalPages = res.pagination.totalPages || _csrTotalPages;
              _appendCards(res.data, grid);
            }
          })
          .catch(function() {})
          .then(function() {
            _csrLoadingMore = false;
            var sp = document.getElementById('csr-scroll-spinner');
            if (sp) sp.style.display = 'none';
          });
        }

        function _setupScrollObserver(grid, gen) {
          /* Clean up previous observer */
          if (_csrScrollObserver) { _csrScrollObserver.disconnect(); _csrScrollObserver = null; }

          /* Remove old sentinel/spinner */
          var oldSentinel = document.getElementById('csr-scroll-sentinel');
          if (oldSentinel) oldSentinel.remove();
          var oldSpinner = document.getElementById('csr-scroll-spinner');
          if (oldSpinner) oldSpinner.remove();

          if (_csrCurrentPage >= _csrTotalPages) return;

          /* Insert spinner + sentinel after the grid */
          var spinnerEl = document.createElement('div');
          spinnerEl.id = 'csr-scroll-spinner';
          spinnerEl.style.cssText = 'display:none;justify-content:center;padding:20px 0;width:100%;';
          spinnerEl.innerHTML = '<svg width="28" height="28" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="animation:csrShimmer 1s linear infinite;"><circle cx="12" cy="12" r="10" fill="none" stroke="#ccc" stroke-width="3"/><path d="M12 2a10 10 0 0 1 10 10" fill="none" stroke="#1a1b18" stroke-width="3" stroke-linecap="round"/></svg>';
          grid.parentNode.insertBefore(spinnerEl, grid.nextSibling);

          var sentinel = document.createElement('div');
          sentinel.id = 'csr-scroll-sentinel';
          sentinel.style.cssText = 'height:1px;width:100%;';
          spinnerEl.parentNode.insertBefore(sentinel, spinnerEl.nextSibling);

          _csrScrollObserver = new IntersectionObserver(function(entries) {
            if (entries[0].isIntersecting && gen === csrRenderGen) {
              _loadNextPage(grid, gen);
            }
          }, { rootMargin: '400px' });
          _csrScrollObserver.observe(sentinel);
        }

        function _buildCard(p) {
          var v0 = (p.variants && p.variants[0]) || {};
          var price = parseFloat(v0.price || p.minPrice || 0);
          var compareAt = parseFloat(v0.compareAtPrice || 0);
          var handle = p.handle || '';
          var url = '/products/' + encodeURIComponent(handle);
          var title = p.title || '';
          var imgSrc = (p.images && p.images.length) ? p.images[0].src : (p.image || '');
          var sep = imgSrc.indexOf('?') !== -1 ? '&' : '?';
          var discount = (compareAt && compareAt > price) ? Math.round(((compareAt - price) / compareAt) * 100) : 0;
          var labels = p.label || [];
          var inStock = !(p.totalInventory != null && p.totalInventory <= 0);
          var variantId = ((v0.shopifyId || v0.id || v0.variantId || '') + '').replace(/.*\//, '');
          var hasMultipleVariants = (p.variants && p.variants.length > 1);

          /* Badge HTML */
          var badgeHtml = '';
          labels.forEach(function(lbl) {
            var bg = lbl === 'Bestseller' ? '#d8a274' : (lbl === 'New' ? '#7c7559' : '#888');
            badgeHtml += '<span class="badge" style="--color-badge-background:' + bg + ';--color-badge-border:var(--color-badge-background);--color-badge-foreground:#ffffff;">' + escH(lbl) + '</span>';
          });

          var discountBadge = discount > 0
            ? '<div class="card__badge--onsale"><span class="badge badge--onsale" aria-hidden="true">' + discount + '% OFF</span></div>'
            : '';

          /* Price HTML */
          var priceHtml = '<div class="price' + (compareAt > price ? ' price--on-sale' : '') + '"><dl>';
          if (compareAt > price) {
            priceHtml += '<div class="price__sale">' +
              '<dd><span class="price-item price-item--sale"><bdi><span class="money">₹' + price.toLocaleString('en-IN') + '</span></bdi></span></dd>' +
              '<dd class="price__compare"><s class="price-item price-item--regular"><bdi><span class="money">₹' + compareAt.toLocaleString('en-IN') + '</span></bdi></s></dd>' +
            '</div>';
          } else {
            priceHtml += '<div class="price__regular"><dd><span class="price-item price-item--regular"><bdi><span class="money">₹' + price.toLocaleString('en-IN') + '</span></bdi></span></dd></div>';
          }
          priceHtml += '</dl></div>';

          /* Rating HTML */
          var ratingHtml = '';
          var avgRating = parseFloat(p.averageRating || 0);
          var reviewCount = parseInt(p.reviewCount || 0, 10);
          if (avgRating > 0 && reviewCount > 0) {
            var reviewLabel = reviewCount < 1000
              ? '(' + reviewCount + ' ' + (reviewCount === 1 ? 'Review' : 'Reviews') + ')'
              : '(' + (reviewCount / 1000).toFixed(1) + 'K ' + 'Reviews)';
            ratingHtml = '<div class="rating" role="img">' +
              '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-star" viewBox="0 0 24 24" width="14" height="14"><path d="M12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26Z" fill="#FFB503"></path></svg>' +
              '<span aria-hidden="true"> ' + avgRating.toFixed(1) + ' </span>' +
              '<span aria-hidden="true"> | </span>' +
              '<svg viewBox="0 0 18 18" class="icon icon-whatsapp-verified" height="14" width="14"><polygon fill="#005eff" points="9,16 7.1,16.9 5.8,15.2 3.7,15.1 3.4,13 1.5,12 2.2,9.9 1.1,8.2 2.6,6.7 2.4,4.6 4.5,4 5.3,2 7.4,2.4 9,1.1 10.7,2.4 12.7,2 13.6,4 15.6,4.6 15.5,6.7 17,8.2 15.9,9.9 16.5,12 14.7,13 14.3,15.1 12.2,15.2 10.9,16.9"></polygon><polygon fill="#FFFFFF" points="13.1,7.3 12.2,6.5 8.1,10.6 5.9,8.5 5,9.4 8,12.4"></polygon></svg>' +
              '<span aria-hidden="true"> ' + reviewLabel + '</span>' +
            '</div>';
          }

          /* ATC button */
          var atcHtml = '';
          if (!inStock) {
            atcHtml = '<button class="csr-btn csr-btn--soldout" type="button" disabled>Sold out</button>';
          } else if (hasMultipleVariants) {
            atcHtml = '<a href="' + url + '" class="csr-btn">View products</a>';
          } else if (variantId) {
            atcHtml = '<button class="csr-btn" type="button" data-csr-atc="' + variantId + '">Add to cart</button>';
          } else {
            /* Partial/cold API response gave no variant id. Resolve it lazily
               from Shopify so single-variant products still get a working
               "Add to cart" and multi-variant ones fall back to "View products",
               instead of everything showing "View products" on the first search. */
            atcHtml = '<button class="csr-btn" type="button" data-csr-lazy="' + escH(handle) + '">Add to cart</button>';
          }

          return '<div class="card-wrapper">' +
            '<a href="' + url + '" class="full-unstyled-link"><span class="visually-hidden">' + escH(title) + '</span></a>' +
            '<use-animate data-animate="zoom-fade-small" class="card card--product" tabindex="-1" animate="">' +
              '<a href="' + url + '" class="card__media media-wrapper" tabindex="-1">' +
                '<div class="image-animate media media--portrait media--hover-effect media--image-contain">' +
                  (imgSrc ? '<img src="' + escH(imgSrc) + sep + 'width=500" alt="' + escH(title) + '" srcset="' + escH(imgSrc) + sep + 'width=200 200w, ' + escH(imgSrc) + sep + 'width=300 300w, ' + escH(imgSrc) + sep + 'width=400 400w, ' + escH(imgSrc) + sep + 'width=500 500w" width="500" height="500" loading="lazy" class="motion-reduce" sizes="(min-width: 1200px) 267px, (min-width: 990px) calc((100vw - 10rem) / 4), (min-width: 750px) calc((100vw - 10rem) / 3), calc(100vw - 3rem)">' : '') +
                '</div>' +
              '</a>' +
              '<div class="card__badge">' + badgeHtml + '</div>' +
              discountBadge +
            '</use-animate>' +
            '<div class="card-information">' +
              '<div class="card-information__wrapper">' +
                '<a href="' + url + '" class="card-information__text h4 text-semi-bold" tabindex="-1">' + escH(title) + '</a>' +
                ratingHtml +
                priceHtml +
              '</div>' +
              '<div class="csr-atc-wrap">' + atcHtml + '</div>' +
            '</div>' +
          '</div>';
        }






        /* ── Cart handlers ── */
        function addToCart(btn, variantId) {
          if (btn.classList.contains("is-loading")) return;
          btn.classList.add("is-loading");
          btn.setAttribute("aria-busy", "true");

          var _miniCart = document.querySelector("mini-cart");
          /* Ask /cart/add.js for exactly the sections the drawer renders. Using
             getSectionsToRender() (instead of a hardcoded list) resolves to
             mini-cart-revamp when the site runs the revamped cart, so
             renderContents receives the right HTML and actually opens the drawer
             — matching the ATC behaviour on PLP/PDP everywhere else. */
          var _sections = (_miniCart && typeof _miniCart.getSectionsToRender === "function")
            ? _miniCart.getSectionsToRender().map(function(s) { return s.id; })
            : [];

          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/javascript",
              "X-Requested-With": "XMLHttpRequest"
            },
            body: JSON.stringify({
              id: parseInt(variantId, 10),
              quantity: 1,
              sections: _sections,
              sections_url: window.location.pathname
            })
          })
          .then(function(r) { return r.json(); })
          .then(function(state) {
            btn.classList.remove("is-loading");
            btn.setAttribute("aria-busy", "false");

            /* Cart API error (e.g. inventory) — leave the page untouched. */
            if (state && state.status) return;

            /* Same flow the rest of the site uses: swap in fresh cart sections
               and open the drawer, so the item reflects instantly. */
            if (_miniCart && typeof _miniCart.renderContents === "function" && state && state.sections) {
              _miniCart.renderContents(state);
            } else if (_miniCart && typeof _miniCart.open === "function") {
              _miniCart.open();
            } else {
              var _bc = document.querySelector(".block-cart");
              if (_bc) { _bc.classList.add("active"); document.body.classList.add("showOverly"); }
            }
          })
          .catch(function() {
            btn.classList.remove("is-loading");
            btn.setAttribute("aria-busy", "false");
          });
        }

        function setupCartHandlers(grid) {
          var fresh = grid.cloneNode(false);
          while (grid.firstChild) fresh.appendChild(grid.firstChild);
          grid.parentNode.replaceChild(fresh, grid);

          /* Pre-resolve lazy buttons silently */
          var lazyBtns = fresh.querySelectorAll("[data-csr-lazy]");
          Array.prototype.forEach.call(lazyBtns, function(btn) {
            var handle = btn.getAttribute("data-csr-lazy");
            fetch("/products/" + encodeURIComponent(handle) + ".json?fields=id,variants")
            .then(function(r) { if (!r.ok) throw new Error(r.status); return r.json(); })
            .then(function(data) {
              var variants = (data.product && data.product.variants) || [];
              if (variants.length === 1) {
                btn.removeAttribute("data-csr-lazy");
                btn.setAttribute("data-csr-atc", variants[0].id);
              } else {
                var a = document.createElement("a");
                a.href = "/products/" + handle;
                a.className = btn.className;
                a.textContent = "View Product";
                if (btn.parentNode) btn.parentNode.replaceChild(a, btn);
              }
            })
            .catch(function() { /* leave as-is on error */ });
          });

          fresh.addEventListener("click", function(e) {
            var atcBtn = e.target.closest ? e.target.closest("[data-csr-atc]") : null;
            if (atcBtn) { e.preventDefault(); addToCart(atcBtn, atcBtn.getAttribute("data-csr-atc")); return; }
            var lazyBtn = e.target.closest ? e.target.closest("[data-csr-lazy]") : null;
            if (!lazyBtn) return;
            e.preventDefault();
            var handle = lazyBtn.getAttribute("data-csr-lazy");
            lazyBtn.disabled = true;
            lazyBtn.textContent = "...";
            fetch("/products/" + encodeURIComponent(handle) + ".json?fields=id,variants")
            .then(function(r) { if (!r.ok) throw new Error(r.status); return r.json(); })
            .then(function(data) {
              var variants = (data.product && data.product.variants) || [];
              if (variants.length === 1) {
                lazyBtn.removeAttribute("data-csr-lazy");
                lazyBtn.setAttribute("data-csr-atc", variants[0].id);
                lazyBtn.disabled = false;
                lazyBtn.textContent = "ADD TO CART";
                addToCart(lazyBtn, variants[0].id);
              } else {
                window.location.href = "/products/" + handle;
              }
            })
            .catch(function() { window.location.href = "/products/" + handle; });
          });
          return fresh;
        }

        function useFallback(query, rid, grid, heading) {
          fetch(
            "/search/suggest.json?q=" + encodeURIComponent(query) +
            "&resources[type]=product&resources[limit]=" + LIMIT +
            "&resources[options][unavailable_products]=last" +
            "&fields=id,title,handle,price,compare_at_price,featured_image,tags"
          )
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
          .then(function (res) {
            if (rid !== csrActiveRid) return;
            var raw = (res.resources && res.resources.results && res.resources.results.products) || [];
            var items = [];
            for (var i = 0; i < raw.length; i++) {
              var p = raw[i];
              if (csrIsHidden(p)) continue;
              items.push({
                id: p.id, handle: p.handle, title: p.title,
                image: p.featured_image && p.featured_image.url,
                minPrice:       parseFloat(p.price) || 0,
                compareAtPrice: parseFloat(p.compare_at_price) || 0,
                tags:           p.tags || []
              });
            }
            if (items.length) {
              renderCards(items, query, grid, heading);
            } else {
              renderNoResults(query, grid, heading);
            }
          })
          .catch(function () {
            if (rid !== csrActiveRid) return;
            renderNoResults(query, grid, heading);
          });
        }

        function showPopularProducts(query, rid, grid, heading) {
          if (rid !== csrActiveRid) return;
          fetch("/products.json?limit=8")
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
          .then(function (res) {
            if (rid !== csrActiveRid) return;
            var raw = (res && res.products) || [];
            if (!raw.length) {
              heading.innerHTML = '<h1 class="csr-title">&nbsp;</h1>';  /* reserve the line — blanking it collapses the box and shifts the page */
              grid.innerHTML = '<p class="csr-msg">No results found for &ldquo;' + escH(query) + '&rdquo;. Try a different keyword.</p>';
              return;
            }
            var items = [];
            for (var i = 0; i < raw.length; i++) {
              var p = raw[i];
              if (csrIsHidden(p)) continue;
              var variant = (p.variants && p.variants[0]) || {};
              items.push({
                id:              p.id,
                handle:          p.handle,
                title:           p.title,
                image:           typeof p.featured_image === "string" ? p.featured_image : (p.featured_image && (p.featured_image.src || p.featured_image.url)) || (p.images && p.images[0] && p.images[0].src),
                minPrice:        parseFloat(variant.price) || 0,
                compareAtPrice:  parseFloat(variant.compare_at_price) || 0,
                variantId:       (p.variants && p.variants.length === 1) ? p.variants[0].id : null,
                isSingleVariant: p.variants ? (p.variants.length === 1) : null,
                tags:            p.tags || []
              });
            }
            renderCards(items, query, grid, heading);
            heading.innerHTML = '<h1 class="csr-title">No results for &ldquo;' + escH(query) + '&rdquo;<span class="csr-count"> &mdash; Showing popular products</span></h1>';
          })
          .catch(function () {
            if (rid !== csrActiveRid) return;
            heading.innerHTML = '<h1 class="csr-title">&nbsp;</h1>';  /* reserve the line — blanking it collapses the box and shifts the page */
            grid.innerHTML = '<p class="csr-msg">No results found for &ldquo;' + escH(query) + '&rdquo;. Try a different keyword.</p>';
          });
        }

        function fetchResults(query, grid, heading) {
          var rid = ++csrActiveRid;
          showShimmer(grid);
          heading.innerHTML = '<h1 class="csr-title">&nbsp;</h1>';  /* reserve the line — blanking it collapses the box and shifts the page */

          var apiSort = _sortKeyToApi[_csrCurrentSort] || 'relevance';

          /* Use the prefetched promise if this is the initial query AND sort is default —
             the fetch was already fired at the top of the IIFE. */
          var apiPromise;
          if (_prefetchPromise && query === _prefetchQ && apiSort === 'relevance') {
            apiPromise = _prefetchPromise;
            _prefetchPromise = null; /* consume once */
          } else {
            _prefetchPromise = null;
            apiPromise = fetch(SEARCH_API_BASE + "/api/v1/search/products?q=" + encodeURIComponent(query) + "&limit=" + LIMIT + "&sort=" + apiSort + "&facets=true", {
              headers: { "X-Shop-Domain": SHOP_DOMAIN_CSR, "X-Session-Id": getSessionId() }
            })
            .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
          }

          apiPromise
          .then(function (res) {
            if (rid !== csrActiveRid) return;
            if (res && res.success && res.data && res.data.length) {
              console.log('[CSR] API success — ' + res.data.length + ' products, facets:', !!res.facets);
              renderCards(res.data, query, grid, heading, res.facets, res.pagination);
            } else {
              console.warn('[CSR] API returned no data — showing no-matches empty state');
              renderNoResults(query, grid, heading);
            }
          })
          .catch(function (err) {
            if (rid !== csrActiveRid) return;
            console.error('[CSR] API failed:', err, '— using Shopify fallback (no facets)');
            useFallback(query, rid, grid, heading);
          });
        }

        function forceFlexGrid(el) {
          if (!el) return;
          el.style.setProperty('display', 'flex', 'important');
          el.style.setProperty('flex-wrap', 'wrap', 'important');
          el.style.setProperty('column-gap', 'var(--grid-horizontal-spacing)', 'important');
          /* Guard: if an app re-sets display:grid, immediately revert */
          if (!el._csrFlexGuard) {
            el._csrFlexGuard = new MutationObserver(function() {
              if (getComputedStyle(el).display !== 'flex') {
                console.warn('[CSR] display hijacked to', getComputedStyle(el).display, '— forcing back to flex');
                el.style.setProperty('display', 'flex', 'important');
                el.style.setProperty('flex-wrap', 'wrap', 'important');
              }
            });
            el._csrFlexGuard.observe(el, { attributes: true, attributeFilter: ['style', 'class'] });
          }
        }

        function bootSearchPage() {
          var gridEl    = document.getElementById("csr-grid");
          var headingEl = document.getElementById("csr-heading");
          if (!gridEl) return;
          forceFlexGrid(gridEl);

          /* Position filter popup: on mobile, keep on body (fixed drawer);
             on desktop, move inside FILTERS+ button wrapper (absolute dropdown) */
          var _fp = document.getElementById('csrf-popup');
          var _fo = document.getElementById('csrf-overlay');
          var _fb = document.getElementById('csr-filter-btn');
          if (_fp) {
            if (window.innerWidth >= 750 && _fb && _fb.parentNode) {
              _fb.parentNode.appendChild(_fp);
            } else {
              document.body.appendChild(_fp);
              if (_fo) document.body.appendChild(_fo);
            }
          }

          /* Wire filter open/close directly (bypass csrFilter.init race) */
          if (_fb && _fp) {
            _fb.addEventListener('click', function(e) {
              e.stopPropagation();
              _fp.classList.toggle('is-open');
              if (_fp.classList.contains('is-open') && window.csrFilter) {
                window.csrFilter._applyFilters();
              }
            });
            document.addEventListener('click', function(e) {
              if (window.innerWidth < 750) return;
              if (!_fp.contains(e.target) && (!_fb || !_fb.contains(e.target))) {
                _fp.classList.remove('is-open');
              }
            });
          }

          /* Init filter internals (price slider, clear, apply, escape) */
          if (window.csrFilter && typeof window.csrFilter.init === 'function') {
            try { window.csrFilter.init(); } catch(e) {}
          }

          /* ── Sort dropdown wiring (desktop) ── */
          var _sortBtn  = document.getElementById('csr-sort-btn');
          var _sortMenu = document.getElementById('csr-sort-menu');
          var _sortLabel = document.getElementById('csr-sort-label');
          if (_sortBtn && _sortMenu) {
            _sortBtn.addEventListener('click', function(e) { e.stopPropagation(); _sortMenu.classList.toggle('is-open'); });
            document.addEventListener('click', function() { _sortMenu.classList.remove('is-open'); });
            _sortMenu.addEventListener('click', function(e) {
              var opt = e.target.closest('.csr-sort-option');
              if (!opt) return;
              Array.prototype.forEach.call(_sortMenu.querySelectorAll('.csr-sort-option'), function(o) { o.classList.remove('is-active'); });
              opt.classList.add('is-active');
              if (_sortLabel) _sortLabel.textContent = opt.textContent.trim().toUpperCase();
              _sortMenu.classList.remove('is-open');
              if (typeof window.applyCsrSort === 'function') window.applyCsrSort(opt.getAttribute('data-sort'));
            });
          }

          /* ── Mobile toolbar wiring ── */
          var _mobSortBtn = document.getElementById('csr-mob-sort-btn');
          var _mobFilterBtn = document.getElementById('csr-mob-filter-btn');
          var _sortSheet = document.getElementById('csr-sort-sheet');
          var _sortSheetOverlay = document.getElementById('csr-sort-sheet-overlay');
          var _sortSheetClose = document.getElementById('csr-sort-sheet-close');
          var _sortSheetList = document.getElementById('csr-sort-sheet-list');

          function openSortSheet() {
            if (_sortSheet) _sortSheet.classList.add('is-open');
            if (_sortSheetOverlay) _sortSheetOverlay.classList.add('is-open');
            document.body.style.overflow = 'hidden';
          }
          function closeSortSheet() {
            if (_sortSheet) _sortSheet.classList.remove('is-open');
            if (_sortSheetOverlay) _sortSheetOverlay.classList.remove('is-open');
            document.body.style.overflow = '';
          }
          if (_mobSortBtn) _mobSortBtn.addEventListener('click', openSortSheet);
          if (_sortSheetClose) _sortSheetClose.addEventListener('click', closeSortSheet);
          if (_sortSheetOverlay) _sortSheetOverlay.addEventListener('click', closeSortSheet);
          if (_sortSheetList) {
            _sortSheetList.addEventListener('click', function(e) {
              var opt = e.target.closest('.csr-sort-sheet-item');
              if (!opt) return;
              var key = opt.getAttribute('data-sort');
              Array.prototype.forEach.call(_sortSheetList.querySelectorAll('.csr-sort-sheet-item'), function(o) { o.classList.remove('is-active'); });
              opt.classList.add('is-active');
              /* Sync desktop dropdown */
              if (_sortMenu) {
                Array.prototype.forEach.call(_sortMenu.querySelectorAll('.csr-sort-option'), function(o) {
                  o.classList.toggle('is-active', o.getAttribute('data-sort') === key);
                });
              }
              if (_sortLabel) _sortLabel.textContent = opt.textContent.trim().toUpperCase();
              closeSortSheet();
              if (typeof window.applyCsrSort === 'function') window.applyCsrSort(key);
            });
          }

          /* Mobile filter button */
          if (_mobFilterBtn) {
            _mobFilterBtn.addEventListener('click', function() {
              if (window.csrFilter) window.csrFilter.open();
            });
          }
          /* ── Client-side sort of the currently loaded cards ──
             Sorting is done entirely in the DOM (no re-fetch) so it NEVER
             rebuilds the filter panel — active filters always survive a sort.
             This matches the filter model, which is also purely client-side
             (it toggles display on the loaded cards). Reorders ALL cards,
             including filter-hidden ones, so a later filter change keeps order. */
          window._csrClientSort = function(key) {
            var g = document.getElementById('csr-grid');
            if (!g) return;
            var cards = Array.prototype.slice.call(g.querySelectorAll('.csr-card'));
            if (!cards.length) return;
            var num = function(el, attr) { return parseFloat(el.getAttribute(attr) || '0') || 0; };
            cards.sort(function(a, b) {
              /* Sold-out products are always deprioritised to the bottom,
                 regardless of the active sort key or applied filters. */
              var soldA = a.getAttribute('data-avail') === 'false' ? 1 : 0;
              var soldB = b.getAttribute('data-avail') === 'false' ? 1 : 0;
              if (soldA !== soldB) return soldA - soldB;
              switch (key) {
                case 'price-low':  return num(a, 'data-price') - num(b, 'data-price');
                case 'price-high': return num(b, 'data-price') - num(a, 'data-price');
                case 'discount':   return num(b, 'data-discount') - num(a, 'data-discount');
                case 'newest': {
                  var na = a.getAttribute('data-date') || '', nb = b.getAttribute('data-date') || '';
                  return na > nb ? -1 : na < nb ? 1 : 0;
                }
                case 'oldest': {
                  var oa = a.getAttribute('data-date') || '', ob = b.getAttribute('data-date') || '';
                  return oa > ob ? 1 : oa < ob ? -1 : 0;
                }
                case 'bestseller': {
                  var ba = num(a, 'data-bestseller'), bb = num(b, 'data-bestseller');
                  if (bb !== ba) return bb - ba;
                  return num(b, 'data-rating') - num(a, 'data-rating');
                }
                case 'relevance':
                default:
                  /* original server order, captured as data-pos at render time */
                  return num(a, 'data-pos') - num(b, 'data-pos');
              }
            });
            var frag = document.createDocumentFragment();
            cards.forEach(function(c) { frag.appendChild(c); });
            g.appendChild(frag);
          };

          window.applyCsrSort = function(key) {
            _csrCurrentSort = key || 'relevance';
            window._csrClientSort(_csrCurrentSort);
          };

          var params = new URLSearchParams(window.location.search);
          var initQ  = (params.get("q") || "").trim();
          var _lastRenderedQ = initQ || '';

          if (initQ) {
            fetchResults(initQ, gridEl, headingEl);
          } else {
            gridEl.innerHTML = '<p class="csr-msg">Search using the header search bar.</p>';
          }

          /* ── Expose global filtered fetch (used by csrFilter._applyFilters) ── */
          window._csrFilteredFetch = function (filterParams) {
            var g = document.getElementById("csr-grid");
            var h = document.getElementById("csr-heading");
            if (!g) return;
            var query = (new URLSearchParams(location.search).get("q") || "").trim();
            if (!query) return;

            showShimmer(g);
            var url = SEARCH_API_BASE + "/api/v1/search/products?q=" + encodeURIComponent(query) + "&limit=" + LIMIT + "&facets=true";
            if (filterParams) url += "&" + filterParams;

            var rid = ++csrActiveRid;
            fetch(url, {
              headers: { "X-Shop-Domain": SHOP_DOMAIN_CSR, "X-Session-Id": getSessionId() }
            })
            .then(function(r) { if (!r.ok) throw new Error(r.status); return r.json(); })
            .then(function(res) {
              if (rid !== csrActiveRid) return;
              if (res && res.success && res.data && res.data.length) {
                var pag = res.pagination || {};
                pag._isFilteredFetch = true;
                renderCards(res.data, query, g, h, res.facets, pag);
              } else {
                h.innerHTML = '<h1 class="csr-title">0 Results found for &ldquo;<strong class="csr-title-query">' + escH(query) + '</strong>&rdquo;:</h1>';
                g.innerHTML = '<p class="csr-msg">No products match the selected filters.</p>';
              }
            })
            .catch(function() {
              if (rid !== csrActiveRid) return;
              g.innerHTML = '<p class="csr-msg">Something went wrong. Please try again.</p>';
            });
          };

          /* ── Expose global re-search (used by popup & interceptors) ──
             Uses fresh getElementById so it always targets the LIVE DOM
             created by mountUI — never a stale reference. */
          window._csrReSearch = function (query) {
            var g = document.getElementById("csr-grid");
            var h = document.getElementById("csr-heading");
            if (!g) return false;
            var currentQ = new URLSearchParams(location.search).get("q") || "";
            if (query !== currentQ) {
              var newUrl = "/pages/custom-search?q=" + encodeURIComponent(query);
              try { history.pushState({ csrQuery: query }, "", newUrl); } catch(e) {}
            }
            _lastRenderedQ = query;
            fetchResults(query, g, h);
            /* Scroll to page top so the site header stays visible. */
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return true;
          };

          /* ── Back/forward between queries — re-fetch without reload ── */
          window.addEventListener("popstate", function () {
            if (location.pathname !== "/pages/custom-search") return;
            var q = (new URLSearchParams(location.search).get("q") || "").trim();
            if (!q) {
              _lastRenderedQ = '';
              var g = document.getElementById("csr-grid");
              var h = document.getElementById("csr-heading");
              if (g) g.innerHTML = '<p class="csr-msg">Search using the header search bar.</p>';
              if (h) h.innerHTML = "";
              return;
            }
            if (q === _lastRenderedQ) return;
            _lastRenderedQ = q;
            var g = document.getElementById("csr-grid");
            var h = document.getElementById("csr-heading");
            if (g) fetchResults(q, g, h);
          });

          /* ── Intercept <a> clicks to /pages/custom-search?q=... ── */
          document.addEventListener("click", function (event) {
            if (location.pathname !== "/pages/custom-search") return;
            var link = event.target.closest("a[href]");
            if (!link) return;
            /* Skip hash-only links (e.g. hamburger menu href="#") — their
               resolved URL inherits the current ?q= param which would
               incorrectly trigger a re-search. */
            var hrefAttr = link.getAttribute("href") || "";
            if (hrefAttr.charAt(0) === "#") return;
            try {
              var u = new URL(link.href, location.origin);
              if (u.pathname !== "/pages/custom-search") return;
              var q = (u.searchParams.get("q") || "").trim();
              if (!q) return;
              event.preventDefault();
              event.stopPropagation();
              if (typeof window._bvClosePopup === "function") window._bvClosePopup(true);
              window._csrReSearch(q);
            } catch(e) {}
          }, true);

          /* ── Intercept form submissions to /pages/custom-search ── */
          document.addEventListener("submit", function (event) {
            if (location.pathname !== "/pages/custom-search") return;
            var form = event.target;
            if (!form || !form.action) return;
            try {
              var actionUrl = new URL(form.action, location.origin);
              if (actionUrl.pathname !== "/pages/custom-search" && actionUrl.pathname !== "/search") return;
            } catch(e) { return; }
            var qInput = form.querySelector("[name='q']");
            if (!qInput) return;
            var q = (qInput.value || "").trim();
            if (!q) { event.preventDefault(); qInput.focus(); return; }
            event.preventDefault();
            if (typeof window._bvClosePopup === "function") window._bvClosePopup(true);
            window._csrReSearch(q);
          }, true);
        }

        if (document.readyState === "loading") {
          document.addEventListener("DOMContentLoaded", mountUI);
        } else {
          mountUI();
        }

      })();
    }

  })();

